// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/about-img/aboutbg_bnr_dark.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/images/about-img/aboutbg_bnr.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../public/images/about-img/built_differently_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
  Arab Global Crypto Exchange - About Us Page CSS
  All classes are prefixed with agc_ to avoid global conflicts 
*/

.agc_about_page_wrapper {
  font-family: 'Inter', 'Roboto', sans-serif;
  color: #111;
  background-color: #ffffff;
  /* mostly white background */
  overflow-x: hidden;
}

/* Team page has no hero — keep content clear of sticky header */
.agc_about_page_wrapper--team {
  padding-top: 40px;
}

.agc_about_page_wrapper--team .agc_about_exec_directors {
  padding-top: 40px;
}

.agc_about_page_wrapper h1,
.agc_about_page_wrapper h2,
.agc_about_page_wrapper h3,
.agc_about_page_wrapper h4 {
  margin-bottom: 15px;
  letter-spacing: 0.5px;
}

.agc_about_title {
  font-size: 60px;
  font-weight: 600;
  position: relative;
}

.agc_about_subtitle {
  color: #D1AA67;
  text-transform: uppercase;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.5px;
  display: block;
  margin-bottom: 10px;
}

.agc_about_text_muted {
  color: #666;
  font-size: 22px;
  font-weight: 300;
  line-height: 1.6;
}

.agc_about_hero_content button {

  font-size: 18px;
  padding: 20px 60px;
  border-radius: 50px;
  font-weight: 600;
}

.agc_about_hero_content button img {
  width: 19px;
}

/* Common Buttons */
.agc_btn_gold {
  background: #D1AA67;
  color: #000000;
  border: none;

  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.agc_btn_gold:hover {
  opacity: 0.9;
  transform: translateY(-2px);
}

.agc_btn_black {
  background: #111;
  color: #fff;
  border: none;
  font-weight: 500 !important;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.agc_btn_black:hover {
  background: #333;
}

/* Scan to Download Popup */
.agc_scan_download_wrapper {
  position: relative;
  display: inline-flex;
}

.agc_scan_download_wrapper .agc_btn_black img {
  filter: invert(1);
}

body.light_theme .agc_scan_download_wrapper .agc_btn_black img {
  filter: invert(0);
}

.agc_scan_popup {
  position: absolute;
  bottom: calc(100% + 15px);
  left: 50%;
  transform: translateX(-50%);
  background: #f4f5f5;
  border-radius: 16px;
  padding: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 220px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 100;
}

/* The arrow pointing down */
.agc_scan_popup::before {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #f4f5f5;
}

.agc_scan_download_wrapper:hover .agc_scan_popup,
.agc_scan_popup:hover {
  opacity: 1;
  visibility: visible;
  bottom: calc(100% + 10px);
}

.agc_scan_qr_container {
  background: #fff;
  padding: 10px;
  border-radius: 12px;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 12px;
}

.agc_scan_qr_container img {
  width: 100%;
  height: auto;
  display: block;
}

.agc_scan_text {
  text-align: center;
  font-size: 15px;
  color: #d1aa67;
  margin-bottom: 15px;
  font-weight: 500;
  line-height: 1.4;
}

.agc_scan_download_btn {
  background: #D1AA67;
  color: #333;
  border: none;
  border-radius: 8px;
  padding: 10px 24px;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  transition: opacity 0.2s;
  width: 100%;
}

.agc_scan_download_btn:hover {
  opacity: 0.9;
}

.agc_btn_outline_gold {
  background: transparent;
  color: #b8860b;
  border: 1px solid #b8860b;
  padding: 8px 20px;
  border-radius: 20px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.agc_btn_outline_gold:hover {
  background: #b8860b;
  color: #fff;
}

/* Blur Backgrounds */
.agc_blur_blue_left_small {
  position: absolute;
  width: 300px;
  height: 300px;
  background: rgba(0, 123, 255, 0.15);
  filter: blur(80px);
  left: -150px;
  top: 50px;
  z-index: 0;
  pointer-events: none;
}

/* HERO SECTION */
.agc_about_hero {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 500px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 70px 0;
  min-height: 960px;
  position: relative;
}

body.light_theme .agc_about_hero {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

/* .agc_about_hero::before {
  width: 100%;
  height: 100%;
  background-color: rgb(24 26 32 / 85%);
  position: absolute;
  content: "";
  top: 0;
  bottom: 0px;
} */

.agc_about_hero .container {
  position: relative;
  z-index: 333;
}


body.light_theme .agc_about_hero::before {
  display: none;
}


.agc_about_hero_content {
  text-align: center;
  max-width: 950px;
  margin: 0 auto;
}

.agc_about_hero_content h1 {
  font-size: 80px;
  line-height: 1.2;
  font-weight: 500;
  margin-bottom: 25px;
  color: #111;
}

.agc_about_hero_content h1 span {
  background: #D1AA67;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.agc_about_hero_content p {
  font-size: 24px;
  color: #dfdfdf;
  margin-bottom: 40px;
  font-weight: 300;
  line-height: 1.6;
}

body.light_theme .agc_about_hero_content p {
  color: #000000;
}

.agc_about_hero_btns {
  display: flex;
  justify-content: center;
  gap: 22px;
  align-items: center;
}

/* TICKER SECTION */
.agc_coin_ticker_wrapper {
  width: 100%;
  overflow: hidden;
  background-color: #ffffff;
  padding: 30px 0;
  white-space: nowrap;
}

.agc_coin_ticker_track {
  display: inline-flex;
  animation: agcTickerScroll 25s linear infinite;
}

.agc_coin_ticker_track:hover {
  animation-play-state: paused;
}

.agc_ticker_item {
  display: inline-flex;
  align-items: center;
  margin-right: 60px;
  font-size: 14px;
}

.agc_ticker_pair {
  color: #777;
  font-weight: 400;
  margin-right: 12px;
}

.agc_ticker_change.agc_up {
  color: #0ecb81;
  /* Green */
}

.agc_ticker_change.agc_down {
  color: #f6465d;
  /* Red */
}

@keyframes agcTickerScroll {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

/* MARKETPLACE SECTION */
.agc_about_marketplace {
  padding: 100px 0;
  position: relative;
  overflow: hidden;
}

.agc_about_marketplace::before,
.agc_about_marketplace::after {
  content: "";
  position: absolute;
  width: 250px;
  height: 250px;
  background: rgb(209 170 103 / 50%);
  filter: blur(100px);
  top: 160px;
  z-index: 0;
  pointer-events: none;
}

.agc_about_marketplace::before {
  left: -100px;
}

.agc_about_marketplace::after {
  right: -100px;
}

.agc_about_marketplace .container {
  position: relative;
  z-index: 1;
}

.agc_about_marketplace_text {
  font-size: 20px;
  color: #d4d4d4;
  line-height: 1.7;
  padding-top: 24px;
}

body.light_theme .agc_about_marketplace_text {
  color: #3D494C;
}

.agc_mission_card {
  background: #f7f9fb0d;
  border: 1px solid #f0f0f00f;
  border-radius: 16px;
  padding: 48px;
  display: flex;
  align-items: flex-start;
  transition: box-shadow 0.3s ease;
  height: 100%;
}

body.light_theme .agc_mission_card {
  background: #F7F9FB;
  border: 1px solid #f0f0f0b5;
}


.agc_mission_card:hover {
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
}

.agc_mission_icon_box {
  width: 100px;
  height: 100px;
  background: #00687a10;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 24px;
  flex-shrink: 0;
}

.agc_mission_icon_box img {
  width: 24px;
  height: 24px;
}

.agc_mission_content h3 {
  font-size: 28px;
  margin-bottom: 10px;
  font-weight: 600;
  color: #191C1E;
}

.agc_mission_content p {
  color: #c7c7c7;
  font-size: 18px;
  line-height: 1.6;
  margin: 15px 0px 0px;
}

body.light_theme .agc_mission_content p {
  color: #3D494C;
}

/* CORE VALUES SECTION */
.agc_about_values {
  padding: 60px 0;
}

.agc_values_grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 36px;
}

.agc_value_card {
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0px 0px 20px #00000015;
  border-radius: 16px;
  padding: 40px;
  text-align: left;
  width: calc(33.333% - 36px);
  min-width: 300px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.agc_value_card_wide {
  width: calc(50% - 36px);
  flex-direction: row;
  align-items: center;
  padding: 40px;
}

.agc_value_card_wide .agc_value_content {
  flex: 1 1;
  padding-right: 20px;
  display: flex;
  flex-direction: column;
}

.agc_value_card_wide h3 {
  margin-bottom: 25px;
  /* more space between title and text in wide mode */
}

.agc_value_card_wide p {
  margin-top: 15px;
}

.agc_value_card_wide .agc_value_img_wrapper {
  flex-shrink: 0;
  width: 240px;
  display: flex;
  justify-content: center;
}

.agc_value_card_wide .agc_value_img {
  width: 100%;
  height: auto;
  max-height: none;
  margin: 0;
}

.agc_value_card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.05);
}

.agc_value_img {
  max-height: 295px;
  object-fit: contain;
  margin-bottom: 10px;
}

.agc_value_card h3 {
  font-size: 34px;
  position: relative;
  font-weight: 700;
  margin-bottom: 15px;
}

.agc_value_card h3::after {
  content: '';
  position: absolute;
  bottom: -7px;
  left: 0;
  width: 84px;
  height: 3.5px;
  background-color: #D1AA67;

}

.agc_value_card p {
  color: #8A8B8B;
  font-size: 20px;
  line-height: 1.6;
  margin-top: 20px;
}

/* COMPARISON SECTION */
.agc_about_comparison {
  padding: 100px 0;
  background-color: #181a20;
  min-height: 1060px;
  position: relative;
  overflow: hidden;
}

body.light_theme .agc_about_comparison {
  background-color: #ffffff;
}

.agc_about_comparison .container {
  position: relative;
  z-index: 1;
}

.agc_about_comparison::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: contain;
  background-position: left center;
  background-repeat: no-repeat;
  opacity: 0.22;
  pointer-events: none;
  z-index: 0;
  transition: opacity 0.3s ease;
}

body.light_theme .agc_about_comparison::before,
body[data-theme="light"] .agc_about_comparison::before {
  opacity: 1;
}

.agc_comparison_layout {
  display: flex;
  gap: 50px;
  align-items: start;
}

.agc_comp_col_left {
  flex: 1 1;
  gap: 50px;
  display: flex;
  margin-top: 60px;
  flex-direction: column;
}

.agc_comp_col_right {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 50px;
}

.agc_comp_card {
  background: #fff;
  border: 1px solid #D1AA67;
  border-radius: 38px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  text-align: left;
}

.agc_comp_card.active_gold {
  background: #fffcf5;
  border: 1px solid #D1AA67;
}



.agc_comp_icon_wrapper {
  width: 146px;
  height: 146px;
  background: #f9f3ea14;
  border-radius: 36px;
  display: flex;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
}

body.light_theme .agc_comp_icon_wrapper {
  background: #F9F3EA;
}

.agc_comp_icon_wrapper img {
  max-width: 90px;
  max-height: 90px;
}

.agc_comp_icon_wrapper.light_icon {
  /* removed the blue background so it uses the gold one */
}

.agc_comp_card h4 {
  font-size: 30px;
  margin: 36px 0 15px 0;
  font-weight: 700;
}

.agc_about_comparison .agc_about_title {
  line-height: 135%;
  font-weight: 700;
}

.agc_comp_card p {
  color: #cacaca;
  font-size: 18px;
  font-weight: 300;
  line-height: 1.5;
  margin: 0;
}

body.light_theme .agc_comp_card p {
  color: #666;
}

.agc_company_info_section.information_section {
  width: 100%;
  background-color: #181A20;
  position: relative;
  padding: 180px 0px 100px;
}

body.light_theme .agc_company_info_section.information_section {

  background-color: #f5f5f5;
}

.agc_company_info_section.information_section .company_info_after {
  max-width: 370px;
  position: absolute;
  right: 0px;
  top: 0px;
}

/* EXPERIENCED OVERSIGHT SECTION */
.agc_about_oversight {
  padding: 80px 0 0 0;
}

.agc_section_header_line {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #D1AA67;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin-bottom: 15px;
  font-size: 20px;
}

.agc_section_header_line::before,
.agc_section_header_line::after {
  content: '';
  height: 1px;
  width: 50px;
  background-color: #D1AA67;
  margin: 0 15px;
}

.agc_btn_solid_gold {
  background: #D1AA67;
  color: #fff;
  border: none;
  border-radius: 30px;
  padding: 12px 28px;
  font-weight: 500;
  font-size: 14px;
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 15px;
  width: -moz-fit-content;
  width: fit-content;
}

.agc_btn_link_gold {
  color: #D1AA67;
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-top: 20px;
}

.agc_oversight_card {
  background: #fff;
  border: 1px solid #eaeaea;
  border-radius: 20px;
  padding: 36px;
  height: 100%;
  text-align: left;
  display: flex;
  flex-direction: row;
  box-shadow: 0px -5px 20px #00000017;
}

.agc_oversight_card.agc_large_card {
  padding: 40px;
}

.agc_oversight_img_wrapper {
  width: 266px;
  margin-right: 30px;
  flex-shrink: 0;
}

.agc_oversight_img {
  width: 100%;
  height: 100%;
  border-radius: 16px;
  object-fit: cover;
  border: 2.5px solid #E2EEFA;
}

.agc_about_oversight h2 {
  font-weight: 700;
}

.agc_oversight_img_wrapper_large {
  width: 320px;
  aspect-ratio: 3 / 4;
  margin-right: 40px;
  flex-shrink: 0;
  border-radius: 20px;
  overflow: hidden;
}

.agc_oversight_img_large {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  object-fit: cover;
  object-position: center top;
  border: 2.5px solid #E2EEFA;
  display: block;
}

.agc_oversight_card.agc_large_card h3 {
  font-size: 36px;
}

.agc_oversight_card.agc_large_card span.agc_role {
  font-size: 22px;
  font-weight: 500;
}

.agc_oversight_card.agc_large_card .agc_oversight_info p {
  font-size: 19px;
}

.agc_oversight_info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.agc_oversight_info h3 {
  font-size: 24px;
  margin-bottom: 5px;
  font-weight: 700;
}

.agc_oversight_info .agc_role {
  color: #2a2a2a;
  font-weight: 700;
  font-size: 17px;
  margin-bottom: 15px;
}

.agc_oversight_info p {
  color: #cbcbcb;
  font-size: 15px;
  line-height: 1.6;
  margin-bottom: 20px;
}

body.light_theme .agc_oversight_info p {
  color: #666;
}

/* LEADERSHIP TEAM SECTION */
.agc_about_team {
  padding: 60px 0 80px 0;
}

.agc_team_card {
  background: #ffffff0d;
  border: 1px solid #eaeaea14;
  border-radius: 20px;
  min-height: 390px;

  padding: 30px;
  text-align: left;
  height: 100%;
  box-shadow: 0px -5px 20px #0000000a;
  display: flex;
  flex-direction: column;
}

body.light_theme .agc_team_card {
  background: #fff;
  border: 1px solid #eaeaea;
}

.agc_team_header {
  margin-bottom: 20px;
}

.agc_team_img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  background-color: #f7f9fc;
  border: 2px solid #fff;
}

.agc_team_name_role h4 {
  font-size: 22px;
  margin-bottom: 5px;
  font-weight: 700;
}

.agc_team_name_role span {
  color: #b7b7b7;
  font-size: 16px;
  display: block;
}

body.light_theme .agc_team_name_role span {
  color: #111;
}

.agc_team_info p {
  color: #bdbdbd;
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
}

body.light_theme .agc_team_info p {
  color: #3a3a3a;
}

/* LICENSE SECTION */
.agc_about_license {
  padding: 40px 0 80px 0;
  background: transparent;
  position: relative;
}

/* .agc_about_license::before,
.agc_about_license::after {
  content: "";
  position: absolute;
  width: 400px;
  height: 400px;
  background: rgba(14, 165, 233, 0.15);
  filter: blur(80px);
  border-radius: 50%;
  z-index: 999;
  pointer-events: none;
}

.agc_about_license::before {
  right: -100px;
  top: 50%;
  transform: translateY(-50%);
}

.agc_about_license::after {
  left: -100px;
  bottom: 0;
} */

.agc_about_license .container {
  position: relative;
  z-index: 1;
}

.agc_licensed_underline {
  position: relative;
  padding-bottom: 2px;
}

.agc_licensed_underline::after {
  content: '';
  width: 35%;
  position: absolute;
  bottom: -5px;
  left: 0;
  border-bottom: 3px solid #D1AA67;
}


.agc_license_card {
  background: #FAFCFB;
  border: 1px solid #f2f2f2;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 40px 50px;
  box-shadow: 0px 5px 25px rgba(0, 0, 0, 0.04);
}

.agc_license_left {
  display: flex;
  align-items: center;
}

.agc_license_icon_outer {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  border: 1px solid #b7ecd629;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 30px;
}

body.light_theme .agc_license_icon_outer {
  border: 1px solid #b7ecd6;
}

.agc_license_icon_inner {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: #e6f9f014;
  display: flex;
  align-items: center;
  justify-content: center;
}

body.light_theme .agc_license_icon_inner {
  background: #e6f9f0;

}

.agc_license_text h4 {
  font-size: 40px;
  font-weight: 600;
  color: #eeeeee;
  margin-bottom: 12px;
}

body.light_theme .agc_license_text h4 {
  color: #111;
}

.agc_license_text p {
  color: #dadada;
  font-size: 22px;
  line-height: 1.6;
  max-width: 100%;
}

body.light_theme .agc_license_text p {
  color: #353535;
}

.agc_about_license .agc_license_text {
  color: #4B5563;
  max-width: 650px;
}

.agc_btn_solid_gold_license {
  background-color: #40434c1f;
  color: #fff;
  border: none;
  border-radius: 3px;
  padding: 10px;
  transition: all 0.5s ease;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
}

body.light_theme .agc_btn_solid_gold_license {
  background-color: #40434c;
  color: #fff;
}

.agc_btn_solid_gold_license:hover {
  box-shadow: 0px 5px 15px #b893526b;
}

/* COMPANY INFO SECTION */
.agc_company_info_subtitle {
  color: #D1AA67;
  font-weight: 400;
  position: relative;
  letter-spacing: 0px;
  text-transform: uppercase;
  font-size: 30px;
}

.agc_company_info_subtitle::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 0;
  border-bottom: 2.5px solid #D1AA67;
  width: 80px;
}

.agc_company_info_subtitle span {
  color: #fff;
}

body.light_theme .agc_company_info_subtitle span {
  color: #0e0e0e;
}

.agc_company_info_card {
  background: #22242C;
  /* border: 1px solid #f2f2f217; */
  position: relative;
  border-radius: 0px;
  padding: 32px 20px;
  box-shadow: 0px 5px 25px rgba(0, 0, 0, 0.04);
  min-height: 245px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  clip-path: polygon(30px 0, 100% 0, 100% calc(100% - 30px), calc(100% - 30px) 100%, 0 100%, 0 30px);
  -webkit-clip-path: polygon(30px 0, 100% 0, 100% calc(100% - 30px), calc(100% - 30px) 100%, 0 100%, 0 30px);
}

.about_icon_after {
  position: absolute;
  right: 40px;
  max-width: 60px;
  top: 40px;
}

.border_bottom_after {
  position: absolute;
  right: 1px;
  bottom: 2px;
}

body.light_theme .border_bottom_after {
  opacity: 0.2;
}

.agc_company_info_section.information_section .row {
  margin-top: 40px;
}

body.light_theme .agc_company_info_card {
  background: #e9e9e9;
  border: 1px solid #f2f2f200;
}

.agc_company_info_header {
  gap: 32px;
  display: flex;
  align-items: center;
}

.agc_company_info_icon {
  width: 111px;
  min-width: 111px;
  height: 111px;
  background: #22242C;
  border: 3px solid #FFCC0030;
  box-shadow: inset 0 0 22px rgb(0 0 0 / 45%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

body.light_theme .agc_company_info_icon {
  background: #efefef;
  box-shadow: inset 0 0 22px rgb(0 0 0 / 29%);
}

.agc_company_info_header h4 {
  font-size: 20px;
  position: relative;
  font-weight: 500;
  color: #D1AA67;
  margin-bottom: 27px;
}

.agc_company_info_header h4::before {
  content: '';
  position: absolute;
  bottom: -13px;
  left: 0px;
  width: 30px;
  height: 3px;
  background: #D1AA67;
}

.agc_company_info_header p {
  font-size: 20px;
  margin: 10px 0px 0px;
}

.agc_company_info_row {
  display: flex;
  justify-content: space-between;
  padding: 16px 0;
  border-bottom: 1px solid #f0f0f029;
}

body.light_theme .agc_company_info_row {
  border-bottom: 1px solid #f0f0f0;
}

.agc_company_info_row:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.agc_company_info_label {
  color: #9298a0;
  font-size: 14px;
  font-weight: 500;
}

.agc_company_info_value {
  color: #f8f8f8;
  font-size: 14px;
  font-weight: 700;
  text-align: right;
  max-width: 65%;
}

body.light_theme .agc_company_info_value {
  color: #111;
}

/* GLOBAL PRESENCE SECTION */
.agc_about_presence {
  padding: 0 0 80px 0;
  background: #fff;
}

.agc_office_card {
  background: #fff;
  border: 1px solid #eaeaea;
  border-radius: 16px;
  padding: 25px;
  display: flex;
  align-items: center;
}

.agc_office_icon {
  width: 50px;
  height: 50px;
  background: #f8f9fa;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  flex-shrink: 0;
}

.agc_office_text h4 {
  font-size: 1.1rem;
}

.agc_office_text p {
  font-size: 0.9rem;
}

/* CTA SECTION */
.agc_cta_banner {
  position: relative;
  background: linear-gradient(90deg, #b58d53 0%, #3a220b 100%);
  border-radius: 20px;
}

.agc_cta_bg_shapes {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  overflow: hidden;
  z-index: 1;
}

.agc_cta_bg_shapes::before,
.agc_cta_bg_shapes::after {
  content: "";
  position: absolute;
  border-radius: 50%;
}

.agc_cta_bg_shapes::before {
  width: 390px;
  height: 390px;
  background: rgb(255 255 255 / 8%);
  bottom: -150px;
  left: -130px;
}

.agc_cta_bg_shapes::after {
  width: 390px;
  height: 390px;
  background: rgb(255 255 255 / 6%);
  top: -150px;
  right: -50px;
}

.agc_cta_content {
  position: relative;
  z-index: 2;
  max-width: 500px;
}

.agc_cta_content h2 {
  font-size: 2.2rem;
}

.agc_cta_img_placeholder {
  position: absolute;
  right: 80px;
  top: 39%;
  transform: translateY(-50%);
  z-index: 1;
}

.agc_about_cta h2 {
  font-size: 42px;
  color: #fff;
}

.agc_about_cta p {
  font-size: 18px;
}

.agc_about_cta button.btn {
  font-size: 14px;
  padding: 13px 36px;
}

.agc_about_cta button.btn:focus {
  background-color: #fff;
  border: 1px solid #fff;
  color: #000000;
}

.agc_cta_chest_img {
  height: 380px !important;
  object-fit: contain;
}

@media (max-width: 1440px) {

  .agc_about_hero_content h1 {
    font-size: 60px;
  }

  .agc_company_info_icon {
    width: 80px;
    min-width: 80px;
    height: 80px;
  }

  .agc_company_info_header {
    gap: 20px;
  }

  .agc_company_info_header p {
    font-size: 18px;
  }

  .agc_about_hero_content button {
    font-size: 18px;
    padding: 18px 50px;
  }

  .agc_about_hero_content p {
    font-size: 20px;
  }

  .agc_about_hero {
    min-height: 800px;
  }

  .agc_about_title {
    font-size: 48px;
  }


}



@media (max-width: 1200px) {

  .agc_about_hero_content h1 {
    font-size: 48px;
  }

  .agc_company_info_header {
    gap: 20px;
    flex-direction: column;
    text-align: center;
  }

  .agc_company_info_header h4::before {
    left: 0px;
    margin: 0 auto;
    right: 0px;
  }

  .agc_comp_icon_wrapper img {
    max-width: 60px;
    max-height: 60px;
  }

  .agc_about_hero_content button {
    font-size: 18px;
    padding: 18px 50px;
  }

  .agc_about_hero_content p {
    font-size: 18px;
  }

  .agc_about_hero {
    min-height: 600px;
  }

  .agc_about_title {
    font-size: 36px;
  }

  .agc_about_marketplace_text {
    font-size: 16px;
  }

  .agc_mission_card {
    padding: 28px;
  }

  .agc_mission_content h3 {
    font-size: 24px;
  }

  .agc_mission_content p {
    font-size: 16px;
  }

  .agc_about_marketplace {
    padding: 60px 0;
  }

  .agc_value_card {
    padding: 26px;
    width: calc(50.333% - 36px);
  }

  .agc_value_card h3 {
    font-size: 26px;
  }

  .agc_value_card p {
    font-size: 16px;
  }

  .agc_value_img {
    max-height: 200px;
  }

  .agc_value_card_wide .agc_value_img_wrapper {
    width: 170px;
  }

  .agc_about_text_muted {
    font-size: 16px;
  }

  .agc_comp_card {
    padding: 24px;
  }

  .agc_comp_card h4 {
    font-size: 22px;
  }

  .agc_comp_card p {
    font-size: 16px;
  }

  .agc_comp_icon_wrapper {
    width: 100px;
    height: 100px;
  }

  .agc_about_comparison {
    padding: 59px 0;
    min-height: 500px;
  }

  .agc_oversight_card {
    flex-direction: column;
    gap: 24px;
  }

  .agc_about_team {
    padding: 50px 0 40px 0;
  }

  .agc_license_text h4 {
    font-size: 26px;
  }

  .agc_license_text p {
    font-size: 16px;
  }

  .agc_about_license .agc_license_text {
    max-width: 70%;
  }

  .agc_license_icon_outer {
    width: 90px;
    height: 90px;
  }

  .agc_license_icon_inner {
    width: 70px;
    height: 70px;
  }

  .agc_about_cta h2 {
    font-size: 32px;
  }


  .agc_cta_chest_img {
    height: 320px !important;
  }

  .agc_cta_img_placeholder {
    right: 20px;
  }


}

/* Responsive adjustments */
@media (max-width: 991px) {

  .agc_comp_col_right {
    width: 100%;
  }

  .agc_company_info_card {
    margin-bottom: 24px;
  }

  .agc_company_info_section.information_section {
    padding: 70px 0px 10px;
  }

  .agc_about_hero {
    min-height: 450px;
  }


  .agc_about_hero_content h1 {
    font-size: 2.8rem;
  }

  .agc_comparison_layout {
    flex-direction: column;
  }

  .agc_value_card {
    width: calc(50% - 20px);
  }

  .agc_cta_banner {
    flex-direction: column;
    text-align: center;
    padding: 40px !important;
  }

  .agc_cta_content {
    margin-bottom: 30px;
  }

  .agc_cta_img_placeholder {
    position: relative;
    right: 0;
    bottom: 0;
    top: 0px;
    transform: translateY(0%);
  }

  .agc_cta_chest_img {
    height: 180px !important;
  }
}

@media (max-width:991px) {


  .agc_about_hero_content h1 {
    font-size: 2.2rem;
  }

  .agc_about_hero_content button {
    font-size: 16px;
    padding: 14px 50px;
  }

  .agc_about_marketplace {
    padding: 40px 0;
  }

  .agc_about_values {
    padding: 40px 0;
  }

  .agc_comp_col_left {
    margin-top: 0px;
  }

  .agc_about_oversight {
    padding: 40px 0 0 0;
  }

  .agc_about_title {
    font-size: 30px;
  }

  .agc_about_hero_content button {
    margin: 0px;
  }

  .agc_btn_black {
    margin-left: 0;
    margin-top: 0;
  }

  .agc_scan_download_wrapper {
    margin-top: 0px;
  }

  .agc_value_card {
    width: 100%;
  }

  .agc_oversight_card.flex-row {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .agc_oversight_img {
    margin-right: 0;
    margin-bottom: 20px;
  }

  .agc_oversight_info.ms-4 {
    margin-left: 0 !important;
  }

  .agc_license_card {
    text-align: center;
  }

  .agc_license_left {
    gap: 20px;
  }

  .agc_license_text h4 {
    font-size: 24px;
  }

  .agc_license_text p {
    font-size: 15px;
  }

  .agc_btn_solid_gold_license {
    padding: 8px;
    font-size: 14px;
  }

  .agc_license_card {
    padding: 24px 30px;
  }

  .agc_btn_solid_gold {
    margin-top: 20px !important;
  }

  .agc_license_icon_inner {
    width: 50px;
    height: 50px;
    padding: 10px;
  }

  .agc_license_icon_outer {
    width: 60px;
    height: 60px;
  }

  .agc_cta_chest_img {
    height: 260px !important;
  }


  .agc_license_icon_outer {
    margin-right: 0;
    margin-bottom: 15px;
  }

  .agc_license_right {
    margin-top: 20px;
  }

  .agc_about_license .agc_license_text {
    max-width: 100%;
    text-align: left;
  }

}




/* --- Profile Modal Styles --- */
.agc_profile_modal_overlay {
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  background: rgb(44 44 44 / 20%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999999;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5%);
  padding: 20px;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition:
    opacity 0.35s ease,
    visibility 0.35s ease,
    -webkit-backdrop-filter 0.35s ease;
  transition:
    opacity 0.35s ease,
    visibility 0.35s ease,
    backdrop-filter 0.35s ease;
  transition:
    opacity 0.35s ease,
    visibility 0.35s ease,
    backdrop-filter 0.35s ease,
    -webkit-backdrop-filter 0.35s ease;
}

body.light_theme .agc_profile_modal_overlay {
  background: rgb(255 255 255 / 20%);
}

.agc_profile_modal_overlay.is-open {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.agc_profile_modal_content {
  background: rgb(4 4 4 / 50%);
  border-radius: 16px;
  width: 100%;
  max-width: 1000px;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5%);
  max-height: 60vh;
  overflow: hidden;
  position: relative;
  padding: 32px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.28);
  display: flex;
  flex-direction: column;
  opacity: 0;
  transform: translateY(28px) scale(0.94);
  transition:
    opacity 0.38s cubic-bezier(0.16, 1, 0.3, 1),
    transform 0.38s cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;
}

body.light_theme .agc_profile_modal_content {
  background: rgb(255 255 255 / 20%);
}

.agc_profile_modal_overlay.is-open .agc_profile_modal_content {
  opacity: 1;
  transform: translateY(0) scale(1);
}

@media (prefers-reduced-motion: reduce) {

  .agc_profile_modal_overlay,
  .agc_profile_modal_content {
    transition: none;
  }

  .agc_profile_modal_content {
    transform: none;
  }
}

.agc_profile_modal_body {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
}

@media (min-width: 768px) {
  .agc_profile_modal_body {
    flex-direction: row;
    gap: 40px;
    align-items: stretch;
  }
}

.agc_profile_modal_close {
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  padding: 0px;
  color: #e9e9e9;
  font-size: 32px;
  cursor: pointer;
  line-height: 1;
  transition: color 0.3s;
}

body.light_theme .agc_profile_modal_close {
  color: #111;
}

.agc_profile_modal_close:hover {
  color: #D1AA67;
}

.agc_profile_modal_img_wrapper {
  flex-shrink: 0;
  width: 100%;
  max-width: 260px;
  aspect-ratio: 3 / 4;
  border-radius: 12px;
  overflow: hidden;
  margin: 0 auto 30px auto;
  align-self: flex-start;
  background: #f4f5f6;
}

.agc_license_right {
  max-width: 150px;
}

@media (min-width: 768px) {

  .agc_profile_modal_img_wrapper {
    width: 260px;
    margin-bottom: 0;
  }
}

.agc_profile_modal_img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: center top;
  border-radius: 12px;
}

.agc_profile_modal_info {
  flex: 1 1;
  overflow-y: auto;
  padding-right: 15px;
}

.agc_profile_modal_info::-webkit-scrollbar {
  width: 6px;
}

.agc_profile_modal_info::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.agc_profile_modal_info::-webkit-scrollbar-thumb {
  background: #D1AA67;
  border-radius: 4px;
}

.agc_profile_modal_info h3 {
  font-size: 22px;
  margin-bottom: 10px;
  color: #ebebeb;
  font-weight: 600;
}

body.light_theme .agc_profile_modal_info h3 {
  color: #111;
}

.agc_profile_modal_info .agc_role {
  display: block;
  color: #D1AA67;
  font-size: 16px;
  margin-bottom: 20px;
  font-weight: 600;
}

.agc_profile_modal_info p {
  color: #afafaf;
  line-height: 1.7;
  font-size: 15px;
  margin: 0;
  white-space: pre-wrap;
}

body.light_theme .agc_profile_modal_info p {
  color: #444;
}

.agc_profile_desc_clamp {
  display: -webkit-box;
  -webkit-line-clamp: 8;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.agc_profile_desc_clamp_15 {
  display: -webkit-box;
  -webkit-line-clamp: 9;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.agc_profile_desc_clamp_4 {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.agc_profile_modal_img_wrapper_small {
  max-width: 100px !important;
  width: 100px !important;
}


/* fix kero - Dark theme support for About pages */
html[data-theme="dark"] .agc_about_page_wrapper,
body:not(.light_theme) .agc_about_page_wrapper {
  background-color: #181a20;
  color: #ffffff;
}

html[data-theme="dark"] .agc_about_page_wrapper h1,
html[data-theme="dark"] .agc_about_page_wrapper h2,
html[data-theme="dark"] .agc_about_page_wrapper h3,
html[data-theme="dark"] .agc_about_page_wrapper h5,
body:not(.light_theme) .agc_about_page_wrapper h1,
body:not(.light_theme) .agc_about_page_wrapper h2,
body:not(.light_theme) .agc_about_page_wrapper h3,
body:not(.light_theme) .agc_about_page_wrapper h5 {
  color: #ffffff;
}

html[data-theme="dark"] .agc_about_text_muted,
body:not(.light_theme) .agc_about_text_muted {
  color: #a0a0a0;
}

html[data-theme="dark"] .agc_scan_popup,
body:not(.light_theme) .agc_scan_popup {
  background: #1a222d;
}

html[data-theme="dark"] .agc_scan_popup::before,
body:not(.light_theme) .agc_scan_popup::before {
  border-top-color: #1a222d;
}

html[data-theme="dark"] .agc_comp_card,
html[data-theme="dark"] .agc_value_card,
html[data-theme="dark"] .agc_company_profile_card,
html[data-theme="dark"] .agc_exec_card,
html[data-theme="dark"] .agc_team_member_card,
html[data-theme="dark"] .agc_oversight_card,
html[data-theme="dark"] .agc_license_card,
body:not(.light_theme) .agc_comp_card,
body:not(.light_theme) .agc_value_card,
body:not(.light_theme) .agc_company_profile_card,
body:not(.light_theme) .agc_exec_card,
body:not(.light_theme) .agc_team_member_card,
body:not(.light_theme) .agc_oversight_card,
body:not(.light_theme) .agc_license_card {
  background: #181a20;
  color: #ffffff;
  border: 1px solid #eaeaea17;
}

html[data-theme="dark"] .agc_comp_card h3,
html[data-theme="dark"] .agc_value_card h3,
html[data-theme="dark"] .agc_company_profile_card h2,
html[data-theme="dark"] .agc_exec_card h3,
html[data-theme="dark"] .agc_team_member_card h3,
html[data-theme="dark"] .agc_oversight_card h3,
html[data-theme="dark"] .agc_license_card h3,
body:not(.light_theme) .agc_comp_card h3,
body:not(.light_theme) .agc_value_card h3,
body:not(.light_theme) .agc_company_profile_card h2,
body:not(.light_theme) .agc_exec_card h3,
body:not(.light_theme) .agc_team_member_card h3,
body:not(.light_theme) .agc_oversight_card h3,
body:not(.light_theme) .agc_license_card h3 {
  color: #ffffff;
}

html[data-theme="dark"] .agc_btn_black,
body:not(.light_theme) .agc_btn_black {
  background: #ffffff;
  color: #111;
}

html[data-theme="dark"] .agc_btn_black:hover,
body:not(.light_theme) .agc_btn_black:hover {
  background: #e0e0e0;
}

html[data-theme="dark"] .agc_role,
body:not(.light_theme) .agc_role {
  color: #a0aab5;
}

/* License Certificate Modal Styling */
.agc_about_license .agc_modal_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999999;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

body.light_theme .agc_about_license .agc_modal_overlay {
  background-color: rgb(255 255 255 / 50%);
}

.agc_about_license .agc_modal_overlay.active {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.agc_about_license .agc_modal_container {
  background: #1a1c2204;
  border-radius: 0px;
  width: 90%;
  max-width: 810px;
  height: auto;
  aspect-ratio: 1.214 / 1;
  max-height: 95vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 50px -12px rgba(209, 170, 103, 0.5);
  overflow: hidden;
  position: relative;
  transform: translate3d(0, 20px, 0) scale(0.95);
  -webkit-transform: translate3d(0, 20px, 0) scale(0.95);
  transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1);
}

.agc_about_license .agc_modal_overlay.active .agc_modal_container {
  transform: translate3d(0, 0, 0) scale(1);
  -webkit-transform: translate3d(0, 0, 0) scale(1);
}

body.light_theme .agc_about_license .agc_modal_container {
  background: #ffffff;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
}

.agc_modal_close_btn.absolute_close {
  position: absolute;
  top: 12px;
  right: 30px;
  z-index: 10;
  background-color: transparent;
  color: #121212;
  /* width: 30px; */
  padding: 0px;
  /* height: 30px; */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: none;
}

.agc_modal_close_btn.absolute_close:hover {
  /* background-color: rgba(209, 170, 103, 0.9); */
  color: #000000;
}

.agc_modal_body.full_body {
  padding: 0;
  background-color: #111216;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  overflow: hidden;
  /* Clip border-radius properly on iOS Safari */
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
}

body.light_theme .agc_modal_body.full_body {
  background-color: #f7f9fb;
}

.agc_modal_body.full_body .agc_pdf_iframe {
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 0px;
  background-color: #ffffff;
  box-shadow: none;
}



/* Mobile Responsiveness */
@media (max-width: 768px) {
  .agc_about_license .agc_modal_container {
    width: 95%;
    height: auto;
    aspect-ratio: 1.414 / 1;
    max-height: 90vh;
    border-radius: 0px;
  }

  .agc_modal_body.full_body {
    padding: 0;
    border-radius: 0px;
  }

  .agc_modal_body.full_body .agc_pdf_iframe {
    border-radius: 0px;
  }
}


@media (max-width:767px) {

  .agc_about_hero_btns {
    flex-direction: column;
    gap: 12px;
  }

  .agc_about_hero {
    min-height: 100%;
    padding: 42px 0px 35px;
  }

  .agc_values_grid {
    gap: 24px;
  }

  .agc_about_page_wrapper--team {
    padding-top: 24px;
  }

  .agc_about_license .agc_modal_container {
    aspect-ratio: 1.0 / 1 !important;
    max-height: 100vh;
  }

  .agc_company_info_section.information_section {
    padding: 40px 0px 0px;
  }

  .agc_company_info_subtitle {
    font-size: 22px;
  }

  .agc_company_info_value {
    font-size: 12px;
  }

  .agc_company_info_icon {
    width: 64px;
    height: 64px;
    min-width: 64px;
  }

  .agc_company_info_icon img {
    width: 30px;
  }

  .agc_company_info_header p {
    font-size: 15px;
  }

  .agc_company_info_header h4 {
    font-size: 17px;
  }

  .agc_company_info_row {
    padding: 10px 0;

  }

  .agc_company_info_label {
    font-size: 12px;
  }

  .agc_btn_solid_gold {
    padding: 10px 28px;
    font-size: 12px;
  }

  .agc_team_name_role h4 {
    font-size: 18px;
  }

  .agc_team_name_role span {
    font-size: 14px;
  }

  .agc_comp_col_left {
    gap: 24px;
  }

  h2.agc_about_title.mb-5 {
    margin-bottom: 22px !important;
  }

  .agc_comp_card h4 {
    margin: 14px 0 10px 0;
    font-size: 18px;
  }

  .agc_comp_icon_wrapper img {
    max-width: 40px;
    max-height: 40px;
  }

  .agc_about_hero_content h1 {
    margin-bottom: 15px;
  }

  .agc_mission_card {
    padding: 24px;
  }

  .agc_mission_content h3 {
    font-size: 20px;
  }

  .agc_value_card.agc_value_card_center {
    flex-direction: column-reverse;
  }

  .agc_about_hero_content button {
    margin: 0px;
    width: 280px;
  }

  .agc_about_hero_content p {
    font-size: 16px;
    margin-bottom: 20px;
  }

  .agc_profile_modal_img_wrapper {
    max-width: 150px;
  }

  .agc_about_marketplace {
    padding: 30px 0 0px;
  }

  .agc_about_title {
    font-size: 24px;
  }

  .agc_about_subtitle {
    font-size: 16px;
  }

  .agc_about_marketplace_text {
    font-size: 15px;
    padding-top: 0px;
  }

  .agc_mission_icon_box {
    width: 60px;
    height: 60px;
    margin-right: 16px;
  }

  .agc_mission_content p {
    font-size: 15px;
    margin-top: 5px;
  }

  .agc_coin_ticker_wrapper {
    padding: 20px 0px;
  }

  .agc_about_marketplace .mb-5 {
    margin-bottom: 2rem !important;
  }

  .agc_about_hero_content button {
    font-size: 14px;
    padding: 12px 50px;
  }

  .agc_scan_text {
    font-size: 14px;
  }

  .agc_scan_download_wrapper {
    margin-top: 0px;
  }

  section.agc_about_cta.mb-5.pb-5 {
    padding-bottom: 0px !important;
  }

  .agc_license_icon_outer {
    width: 50px;
    height: 50px;
    min-width: 50px;
  }

  .agc_about_values {
    padding: 20px 0 10px;
  }

  .agc_about_page_wrapper--team .agc_about_exec_directors {
    padding-top: 20px;
    padding-bottom: 0px !important;
  }

  .agc_profile_modal_overlay {
    align-items: end;
    padding: 0px;
  }

  .text-center.mb-5 {
    margin-bottom: 15px !important;
  }

  .agc_value_card h3 {
    font-size: 18px;
  }

  .agc_value_card.agc_value_card_wide {
    flex-direction: column-reverse;
  }

  .agc_about_comparison {
    padding: 30px 0;
    min-height: 100%;
  }

  .agc_comparison_layout {
    gap: 30px;
  }

  .agc_section_header_line {
    font-size: 16px;
  }

  .agc_oversight_card {
    padding: 24px;
  }

  .agc_oversight_info h3 {
    font-size: 20px;
  }

  .agc_oversight_img_wrapper_large {
    width: 100%;
    margin-right: 0px;
  }

  .agc_oversight_card.agc_large_card {
    padding: 24px;
  }

  .agc_oversight_card.agc_large_card h3 {
    font-size: 20px;
  }

  .agc_oversight_card.agc_large_card span.agc_role {
    font-size: 14px;
  }

  .agc_oversight_card.agc_large_card .agc_oversight_info p {
    font-size: 14px;
  }

  .agc_oversight_info p,
  .agc_team_info p {
    text-align: justify;
    text-justify: inter-word;
    -webkit-hyphens: auto;
    font-size: 14px;
    hyphens: auto;
    word-break: break-word;
  }

  .agc_oversight_info .agc_role {
    font-size: 14px;
  }

  .agc_about_team {
    padding: 20px 0 20px 0;
  }

  .agc_about_license {
    padding: 30px 0 30px 0;
  }

  .agc_license_card {
    flex-direction: column;
  }

  .agc_license_text h4 {
    font-size: 20px;
  }

  .agc_license_text p {
    font-size: 14px;
  }

  .agc_btn_solid_gold_license {
    font-size: 13px;
  }

  .agc_license_card {
    padding: 20px;
  }

  .agc_company_info_card {
    padding: 24px;
    min-height: 230px;
  }

  .agc_about_cta h2 {
    font-size: 24px;
  }

  .agc_about_cta p {
    font-size: 15px;
  }

  .agc_cta_content {
    padding-left: 0px !important;
  }

  .agc_about_cta button.btn {
    font-size: 14px;
    padding: 12px 21px;
  }

  .agc_comp_col_right {
    gap: 30px;
  }

  .agc_value_card.agc_value_card_center h3 {
    order: 3;
  }

  .agc_value_card.agc_value_card_center .agc_value_img {
    order: 3;
  }

  .agc_value_card.agc_value_card_center p {
    order: 1;
  }

  .agc_cta_banner {
    padding: 19px !important;
  }

  .agc_team_card {
    min-height: 100%;
  }


  .agc_btn_link_gold {
    margin-top: 24px !important;
  }

  .agc_oversight_img_wrapper {
    width: 100%;
    margin-right: 0px;
  }

  .col-lg-5.mb-5 {
    margin-bottom: 15px !important;
  }

  .agc_about_hero_content button img {
    width: 20px;
  }

  .agc_profile_modal_content {
    padding: 20px;
    border-radius: 18px 18px 0px 0px;
    max-height: 92vh;
    min-height: 75vh;
  }

  .agc_profile_modal_info h3 {
    font-size: 18px;
  }

  .agc_profile_modal_info .agc_role {
    font-size: 14px;
    margin-bottom: 12px;
  }

  .agc_profile_modal_info {
    padding-right: 0px;
  }

  .agc_profile_modal_info p {
    font-size: 14px;
  }

  .agc_cta_content {
    margin-bottom: 0px;
  }

  .agc_about_text_muted {
    font-size: 15px;
  }

  .agc_comp_card p {
    font-size: 15px;
  }

  .agc_comp_icon_wrapper {
    width: 70px;
    height: 70px;
    border-radius: 18px;
  }

  .agc_value_card p {
    font-size: 14px;
  }

  .agc_value_img {
    max-height: 150px;
    margin-top: 0px !important;
  }

  .agc_value_card_wide .agc_value_img_wrapper {
    width: 150px;
  }

  .agc_about_hero_content h1 {
    font-size: 26px;
  }

  .agc_about_license .agc_modal_container {
    width: 100%;
  }

}

@media screen and (max-width:667px) {

  .agc_about_title {
    font-size: 18px;
    margin-bottom: 12px !important;
  }

  .agc_about_hero_content button {
    font-size: 12px;
    padding: 10px 50px;
  }

  .agc_mission_content p {
    font-size: 14px;
  }

  .agc_mission_content h3 {
    font-size: 18px;
  }

}


@media screen and (max-width:480px) {

  .agc_about_hero_content h1 {
    font-size: 24px;
  }

  .agc_about_hero_content p {
    font-size: 15px;
  }

  .agc_about_cta p {
    font-size: 14px;
  }

  .agc_company_info_value {
    font-size: 12px;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/AboutUs/about-us.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED;EACE,0CAA0C;EAC1C,WAAW;EACX,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,gEAAgE;AAChE;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;;EAEZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;;EAEE,UAAU;EACV,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,yDAAiF;EACjF,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yDAA4E;AAC9E;;AAEA;;;;;;;;GAQG;;AAEH;EACE,kBAAkB;EAClB,YAAY;AACd;;;AAGA;EACE,aAAa;AACf;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,QAAQ;AACV;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,UAAU;EACV,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;;AAGA;EACE,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,qDAAqD;EACrD,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,aAAa;EACb,yBAAyB;;AAE3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,yDAAqF;EACrF,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,aAAa;EACb,oBAAoB;EACpB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;;;AAIA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;;EAEjB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,mCAAmC;EACnC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;;;GAsBG;;AAEH;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,gCAAgC;AAClC;;;AAGA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;;AAErB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,4CAA4C;EAC5C,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,kGAAkG;EAClG,0GAA0G;AAC5G;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,4DAA4D;EAC5D,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iCAAiC;EACjC,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iCAAiC;EACjC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;;AAGF;;;;AAIA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;;EAGA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;;;AAGF;;AAEA,2BAA2B;AAC3B;;EAEE;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;;EAGA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,QAAQ;IACR,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;;;EAGE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;;;EAGA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;AAEF;;;;;AAKA,iCAAiC;AACjC;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,iCAAiC;EACjC,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB;;;sCAG4B;EAH5B;;;8BAG4B;EAH5B;;;;sCAG4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,0BAA0B;EAC1B,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,uCAAuC;EACvC;;iDAE+C;EAC/C,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;;EAEE;;IAEE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;AACf;;AAEA;EACE;IACE,mBAAmB;IACnB,SAAS;IACT,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;;AAGA,kDAAkD;AAClD;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;;;;;;EAQE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;;;EAcE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;;;;;;;;;;;;;;EAcE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,mCAAmC;EACnC,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,sDAAsD;EACtD,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;EAC9C,sDAAsD;EACtD,yDAAgH;AAClH;;AAEA;EACE,wCAAwC;EACxC,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,6BAA6B;EAC7B,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;;;AAIA,0BAA0B;AAC1B;EACE;IACE,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;;AAGA;;EAEE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gCAAgC;IAChC,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;;EAEjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,mBAAmB;IACnB,wBAAwB;IACxB,qBAAqB;IACrB,eAAe;IAGf,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;;EAGA;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;AAEF;;AAEA;;EAEE;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;;AAGA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF","sourcesContent":["/* \n  Arab Global Crypto Exchange - About Us Page CSS\n  All classes are prefixed with agc_ to avoid global conflicts \n*/\n\n.agc_about_page_wrapper {\n  font-family: 'Inter', 'Roboto', sans-serif;\n  color: #111;\n  background-color: #ffffff;\n  /* mostly white background */\n  overflow-x: hidden;\n}\n\n/* Team page has no hero — keep content clear of sticky header */\n.agc_about_page_wrapper--team {\n  padding-top: 40px;\n}\n\n.agc_about_page_wrapper--team .agc_about_exec_directors {\n  padding-top: 40px;\n}\n\n.agc_about_page_wrapper h1,\n.agc_about_page_wrapper h2,\n.agc_about_page_wrapper h3,\n.agc_about_page_wrapper h4 {\n  margin-bottom: 15px;\n  letter-spacing: 0.5px;\n}\n\n.agc_about_title {\n  font-size: 60px;\n  font-weight: 600;\n  position: relative;\n}\n\n.agc_about_subtitle {\n  color: #D1AA67;\n  text-transform: uppercase;\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  display: block;\n  margin-bottom: 10px;\n}\n\n.agc_about_text_muted {\n  color: #666;\n  font-size: 22px;\n  font-weight: 300;\n  line-height: 1.6;\n}\n\n.agc_about_hero_content button {\n\n  font-size: 18px;\n  padding: 20px 60px;\n  border-radius: 50px;\n  font-weight: 600;\n}\n\n.agc_about_hero_content button img {\n  width: 19px;\n}\n\n/* Common Buttons */\n.agc_btn_gold {\n  background: #D1AA67;\n  color: #000000;\n  border: none;\n\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.agc_btn_gold:hover {\n  opacity: 0.9;\n  transform: translateY(-2px);\n}\n\n.agc_btn_black {\n  background: #111;\n  color: #fff;\n  border: none;\n  font-weight: 500 !important;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.agc_btn_black:hover {\n  background: #333;\n}\n\n/* Scan to Download Popup */\n.agc_scan_download_wrapper {\n  position: relative;\n  display: inline-flex;\n}\n\n.agc_scan_download_wrapper .agc_btn_black img {\n  filter: invert(1);\n}\n\nbody.light_theme .agc_scan_download_wrapper .agc_btn_black img {\n  filter: invert(0);\n}\n\n.agc_scan_popup {\n  position: absolute;\n  bottom: calc(100% + 15px);\n  left: 50%;\n  transform: translateX(-50%);\n  background: #f4f5f5;\n  border-radius: 16px;\n  padding: 15px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 220px;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n  z-index: 100;\n}\n\n/* The arrow pointing down */\n.agc_scan_popup::before {\n  content: '';\n  position: absolute;\n  bottom: -8px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-top: 8px solid #f4f5f5;\n}\n\n.agc_scan_download_wrapper:hover .agc_scan_popup,\n.agc_scan_popup:hover {\n  opacity: 1;\n  visibility: visible;\n  bottom: calc(100% + 10px);\n}\n\n.agc_scan_qr_container {\n  background: #fff;\n  padding: 10px;\n  border-radius: 12px;\n  width: 100%;\n  box-sizing: border-box;\n  margin-bottom: 12px;\n}\n\n.agc_scan_qr_container img {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.agc_scan_text {\n  text-align: center;\n  font-size: 15px;\n  color: #d1aa67;\n  margin-bottom: 15px;\n  font-weight: 500;\n  line-height: 1.4;\n}\n\n.agc_scan_download_btn {\n  background: #D1AA67;\n  color: #333;\n  border: none;\n  border-radius: 8px;\n  padding: 10px 24px;\n  font-weight: 600;\n  font-size: 15px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n  width: 100%;\n}\n\n.agc_scan_download_btn:hover {\n  opacity: 0.9;\n}\n\n.agc_btn_outline_gold {\n  background: transparent;\n  color: #b8860b;\n  border: 1px solid #b8860b;\n  padding: 8px 20px;\n  border-radius: 20px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.agc_btn_outline_gold:hover {\n  background: #b8860b;\n  color: #fff;\n}\n\n/* Blur Backgrounds */\n.agc_blur_blue_left_small {\n  position: absolute;\n  width: 300px;\n  height: 300px;\n  background: rgba(0, 123, 255, 0.15);\n  filter: blur(80px);\n  left: -150px;\n  top: 50px;\n  z-index: 0;\n  pointer-events: none;\n}\n\n/* HERO SECTION */\n.agc_about_hero {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 500px;\n  background-image: url('../../../../public/images/about-img/aboutbg_bnr_dark.jpg');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  padding: 70px 0;\n  min-height: 960px;\n  position: relative;\n}\n\nbody.light_theme .agc_about_hero {\n  background-image: url('../../../../public/images/about-img/aboutbg_bnr.jpg');\n}\n\n/* .agc_about_hero::before {\n  width: 100%;\n  height: 100%;\n  background-color: rgb(24 26 32 / 85%);\n  position: absolute;\n  content: \"\";\n  top: 0;\n  bottom: 0px;\n} */\n\n.agc_about_hero .container {\n  position: relative;\n  z-index: 333;\n}\n\n\nbody.light_theme .agc_about_hero::before {\n  display: none;\n}\n\n\n.agc_about_hero_content {\n  text-align: center;\n  max-width: 950px;\n  margin: 0 auto;\n}\n\n.agc_about_hero_content h1 {\n  font-size: 80px;\n  line-height: 1.2;\n  font-weight: 500;\n  margin-bottom: 25px;\n  color: #111;\n}\n\n.agc_about_hero_content h1 span {\n  background: #D1AA67;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.agc_about_hero_content p {\n  font-size: 24px;\n  color: #dfdfdf;\n  margin-bottom: 40px;\n  font-weight: 300;\n  line-height: 1.6;\n}\n\nbody.light_theme .agc_about_hero_content p {\n  color: #000000;\n}\n\n.agc_about_hero_btns {\n  display: flex;\n  justify-content: center;\n  gap: 22px;\n  align-items: center;\n}\n\n/* TICKER SECTION */\n.agc_coin_ticker_wrapper {\n  width: 100%;\n  overflow: hidden;\n  background-color: #ffffff;\n  padding: 30px 0;\n  white-space: nowrap;\n}\n\n.agc_coin_ticker_track {\n  display: inline-flex;\n  animation: agcTickerScroll 25s linear infinite;\n}\n\n.agc_coin_ticker_track:hover {\n  animation-play-state: paused;\n}\n\n.agc_ticker_item {\n  display: inline-flex;\n  align-items: center;\n  margin-right: 60px;\n  font-size: 14px;\n}\n\n.agc_ticker_pair {\n  color: #777;\n  font-weight: 400;\n  margin-right: 12px;\n}\n\n.agc_ticker_change.agc_up {\n  color: #0ecb81;\n  /* Green */\n}\n\n.agc_ticker_change.agc_down {\n  color: #f6465d;\n  /* Red */\n}\n\n@keyframes agcTickerScroll {\n  0% {\n    transform: translateX(0);\n  }\n\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n/* MARKETPLACE SECTION */\n.agc_about_marketplace {\n  padding: 100px 0;\n  position: relative;\n  overflow: hidden;\n}\n\n.agc_about_marketplace::before,\n.agc_about_marketplace::after {\n  content: \"\";\n  position: absolute;\n  width: 250px;\n  height: 250px;\n  background: rgb(209 170 103 / 50%);\n  filter: blur(100px);\n  top: 160px;\n  z-index: 0;\n  pointer-events: none;\n}\n\n.agc_about_marketplace::before {\n  left: -100px;\n}\n\n.agc_about_marketplace::after {\n  right: -100px;\n}\n\n.agc_about_marketplace .container {\n  position: relative;\n  z-index: 1;\n}\n\n.agc_about_marketplace_text {\n  font-size: 20px;\n  color: #d4d4d4;\n  line-height: 1.7;\n  padding-top: 24px;\n}\n\nbody.light_theme .agc_about_marketplace_text {\n  color: #3D494C;\n}\n\n.agc_mission_card {\n  background: #f7f9fb0d;\n  border: 1px solid #f0f0f00f;\n  border-radius: 16px;\n  padding: 48px;\n  display: flex;\n  align-items: flex-start;\n  transition: box-shadow 0.3s ease;\n  height: 100%;\n}\n\nbody.light_theme .agc_mission_card {\n  background: #F7F9FB;\n  border: 1px solid #f0f0f0b5;\n}\n\n\n.agc_mission_card:hover {\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);\n}\n\n.agc_mission_icon_box {\n  width: 100px;\n  height: 100px;\n  background: #00687a10;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 24px;\n  flex-shrink: 0;\n}\n\n.agc_mission_icon_box img {\n  width: 24px;\n  height: 24px;\n}\n\n.agc_mission_content h3 {\n  font-size: 28px;\n  margin-bottom: 10px;\n  font-weight: 600;\n  color: #191C1E;\n}\n\n.agc_mission_content p {\n  color: #c7c7c7;\n  font-size: 18px;\n  line-height: 1.6;\n  margin: 15px 0px 0px;\n}\n\nbody.light_theme .agc_mission_content p {\n  color: #3D494C;\n}\n\n/* CORE VALUES SECTION */\n.agc_about_values {\n  padding: 60px 0;\n}\n\n.agc_values_grid {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 36px;\n}\n\n.agc_value_card {\n  background: #fff;\n  border: 1px solid #eaeaea;\n  box-shadow: 0px 0px 20px #00000015;\n  border-radius: 16px;\n  padding: 40px;\n  text-align: left;\n  width: calc(33.333% - 36px);\n  min-width: 300px;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.agc_value_card_wide {\n  width: calc(50% - 36px);\n  flex-direction: row;\n  align-items: center;\n  padding: 40px;\n}\n\n.agc_value_card_wide .agc_value_content {\n  flex: 1 1;\n  padding-right: 20px;\n  display: flex;\n  flex-direction: column;\n}\n\n.agc_value_card_wide h3 {\n  margin-bottom: 25px;\n  /* more space between title and text in wide mode */\n}\n\n.agc_value_card_wide p {\n  margin-top: 15px;\n}\n\n.agc_value_card_wide .agc_value_img_wrapper {\n  flex-shrink: 0;\n  width: 240px;\n  display: flex;\n  justify-content: center;\n}\n\n.agc_value_card_wide .agc_value_img {\n  width: 100%;\n  height: auto;\n  max-height: none;\n  margin: 0;\n}\n\n.agc_value_card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.05);\n}\n\n.agc_value_img {\n  max-height: 295px;\n  object-fit: contain;\n  margin-bottom: 10px;\n}\n\n.agc_value_card h3 {\n  font-size: 34px;\n  position: relative;\n  font-weight: 700;\n  margin-bottom: 15px;\n}\n\n.agc_value_card h3::after {\n  content: '';\n  position: absolute;\n  bottom: -7px;\n  left: 0;\n  width: 84px;\n  height: 3.5px;\n  background-color: #D1AA67;\n\n}\n\n.agc_value_card p {\n  color: #8A8B8B;\n  font-size: 20px;\n  line-height: 1.6;\n  margin-top: 20px;\n}\n\n/* COMPARISON SECTION */\n.agc_about_comparison {\n  padding: 100px 0;\n  background-color: #181a20;\n  min-height: 1060px;\n  position: relative;\n  overflow: hidden;\n}\n\nbody.light_theme .agc_about_comparison {\n  background-color: #ffffff;\n}\n\n.agc_about_comparison .container {\n  position: relative;\n  z-index: 1;\n}\n\n.agc_about_comparison::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background-image: url('../../../../public/images/about-img/built_differently_bg.png');\n  background-size: contain;\n  background-position: left center;\n  background-repeat: no-repeat;\n  opacity: 0.22;\n  pointer-events: none;\n  z-index: 0;\n  transition: opacity 0.3s ease;\n}\n\nbody.light_theme .agc_about_comparison::before,\nbody[data-theme=\"light\"] .agc_about_comparison::before {\n  opacity: 1;\n}\n\n.agc_comparison_layout {\n  display: flex;\n  gap: 50px;\n  align-items: start;\n}\n\n.agc_comp_col_left {\n  flex: 1 1;\n  gap: 50px;\n  display: flex;\n  margin-top: 60px;\n  flex-direction: column;\n}\n\n.agc_comp_col_right {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 50px;\n}\n\n.agc_comp_card {\n  background: #fff;\n  border: 1px solid #D1AA67;\n  border-radius: 38px;\n  padding: 40px;\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n}\n\n.agc_comp_card.active_gold {\n  background: #fffcf5;\n  border: 1px solid #D1AA67;\n}\n\n\n\n.agc_comp_icon_wrapper {\n  width: 146px;\n  height: 146px;\n  background: #f9f3ea14;\n  border-radius: 36px;\n  display: flex;\n  margin: 0 auto;\n  align-items: center;\n  justify-content: center;\n}\n\nbody.light_theme .agc_comp_icon_wrapper {\n  background: #F9F3EA;\n}\n\n.agc_comp_icon_wrapper img {\n  max-width: 90px;\n  max-height: 90px;\n}\n\n.agc_comp_icon_wrapper.light_icon {\n  /* removed the blue background so it uses the gold one */\n}\n\n.agc_comp_card h4 {\n  font-size: 30px;\n  margin: 36px 0 15px 0;\n  font-weight: 700;\n}\n\n.agc_about_comparison .agc_about_title {\n  line-height: 135%;\n  font-weight: 700;\n}\n\n.agc_comp_card p {\n  color: #cacaca;\n  font-size: 18px;\n  font-weight: 300;\n  line-height: 1.5;\n  margin: 0;\n}\n\nbody.light_theme .agc_comp_card p {\n  color: #666;\n}\n\n.agc_company_info_section.information_section {\n  width: 100%;\n  background-color: #181A20;\n  position: relative;\n  padding: 180px 0px 100px;\n}\n\nbody.light_theme .agc_company_info_section.information_section {\n\n  background-color: #f5f5f5;\n}\n\n.agc_company_info_section.information_section .company_info_after {\n  max-width: 370px;\n  position: absolute;\n  right: 0px;\n  top: 0px;\n}\n\n/* EXPERIENCED OVERSIGHT SECTION */\n.agc_about_oversight {\n  padding: 80px 0 0 0;\n}\n\n.agc_section_header_line {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #D1AA67;\n  font-weight: 700;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  margin-bottom: 15px;\n  font-size: 20px;\n}\n\n.agc_section_header_line::before,\n.agc_section_header_line::after {\n  content: '';\n  height: 1px;\n  width: 50px;\n  background-color: #D1AA67;\n  margin: 0 15px;\n}\n\n.agc_btn_solid_gold {\n  background: #D1AA67;\n  color: #fff;\n  border: none;\n  border-radius: 30px;\n  padding: 12px 28px;\n  font-weight: 500;\n  font-size: 14px;\n  text-transform: uppercase;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 15px;\n  width: fit-content;\n}\n\n.agc_btn_link_gold {\n  color: #D1AA67;\n  font-weight: 700;\n  font-size: 13px;\n  text-transform: uppercase;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  margin-top: 20px;\n}\n\n.agc_oversight_card {\n  background: #fff;\n  border: 1px solid #eaeaea;\n  border-radius: 20px;\n  padding: 36px;\n  height: 100%;\n  text-align: left;\n  display: flex;\n  flex-direction: row;\n  box-shadow: 0px -5px 20px #00000017;\n}\n\n.agc_oversight_card.agc_large_card {\n  padding: 40px;\n}\n\n.agc_oversight_img_wrapper {\n  width: 266px;\n  margin-right: 30px;\n  flex-shrink: 0;\n}\n\n.agc_oversight_img {\n  width: 100%;\n  height: 100%;\n  border-radius: 16px;\n  object-fit: cover;\n  border: 2.5px solid #E2EEFA;\n}\n\n.agc_about_oversight h2 {\n  font-weight: 700;\n}\n\n.agc_oversight_img_wrapper_large {\n  width: 320px;\n  aspect-ratio: 3 / 4;\n  margin-right: 40px;\n  flex-shrink: 0;\n  border-radius: 20px;\n  overflow: hidden;\n}\n\n.agc_oversight_img_large {\n  width: 100%;\n  height: 100%;\n  border-radius: 20px;\n  object-fit: cover;\n  object-position: center top;\n  border: 2.5px solid #E2EEFA;\n  display: block;\n}\n\n.agc_oversight_card.agc_large_card h3 {\n  font-size: 36px;\n}\n\n.agc_oversight_card.agc_large_card span.agc_role {\n  font-size: 22px;\n  font-weight: 500;\n}\n\n.agc_oversight_card.agc_large_card .agc_oversight_info p {\n  font-size: 19px;\n}\n\n.agc_oversight_info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.agc_oversight_info h3 {\n  font-size: 24px;\n  margin-bottom: 5px;\n  font-weight: 700;\n}\n\n.agc_oversight_info .agc_role {\n  color: #2a2a2a;\n  font-weight: 700;\n  font-size: 17px;\n  margin-bottom: 15px;\n}\n\n.agc_oversight_info p {\n  color: #cbcbcb;\n  font-size: 15px;\n  line-height: 1.6;\n  margin-bottom: 20px;\n}\n\nbody.light_theme .agc_oversight_info p {\n  color: #666;\n}\n\n/* LEADERSHIP TEAM SECTION */\n.agc_about_team {\n  padding: 60px 0 80px 0;\n}\n\n.agc_team_card {\n  background: #ffffff0d;\n  border: 1px solid #eaeaea14;\n  border-radius: 20px;\n  min-height: 390px;\n\n  padding: 30px;\n  text-align: left;\n  height: 100%;\n  box-shadow: 0px -5px 20px #0000000a;\n  display: flex;\n  flex-direction: column;\n}\n\nbody.light_theme .agc_team_card {\n  background: #fff;\n  border: 1px solid #eaeaea;\n}\n\n.agc_team_header {\n  margin-bottom: 20px;\n}\n\n.agc_team_img {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  object-fit: cover;\n  background-color: #f7f9fc;\n  border: 2px solid #fff;\n}\n\n.agc_team_name_role h4 {\n  font-size: 22px;\n  margin-bottom: 5px;\n  font-weight: 700;\n}\n\n.agc_team_name_role span {\n  color: #b7b7b7;\n  font-size: 16px;\n  display: block;\n}\n\nbody.light_theme .agc_team_name_role span {\n  color: #111;\n}\n\n.agc_team_info p {\n  color: #bdbdbd;\n  font-size: 14px;\n  line-height: 1.6;\n  margin: 0;\n}\n\nbody.light_theme .agc_team_info p {\n  color: #3a3a3a;\n}\n\n/* LICENSE SECTION */\n.agc_about_license {\n  padding: 40px 0 80px 0;\n  background: transparent;\n  position: relative;\n}\n\n/* .agc_about_license::before,\n.agc_about_license::after {\n  content: \"\";\n  position: absolute;\n  width: 400px;\n  height: 400px;\n  background: rgba(14, 165, 233, 0.15);\n  filter: blur(80px);\n  border-radius: 50%;\n  z-index: 999;\n  pointer-events: none;\n}\n\n.agc_about_license::before {\n  right: -100px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.agc_about_license::after {\n  left: -100px;\n  bottom: 0;\n} */\n\n.agc_about_license .container {\n  position: relative;\n  z-index: 1;\n}\n\n.agc_licensed_underline {\n  position: relative;\n  padding-bottom: 2px;\n}\n\n.agc_licensed_underline::after {\n  content: '';\n  width: 35%;\n  position: absolute;\n  bottom: -5px;\n  left: 0;\n  border-bottom: 3px solid #D1AA67;\n}\n\n\n.agc_license_card {\n  background: #FAFCFB;\n  border: 1px solid #f2f2f2;\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 40px 50px;\n  box-shadow: 0px 5px 25px rgba(0, 0, 0, 0.04);\n}\n\n.agc_license_left {\n  display: flex;\n  align-items: center;\n}\n\n.agc_license_icon_outer {\n  width: 110px;\n  height: 110px;\n  border-radius: 50%;\n  border: 1px solid #b7ecd629;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 30px;\n}\n\nbody.light_theme .agc_license_icon_outer {\n  border: 1px solid #b7ecd6;\n}\n\n.agc_license_icon_inner {\n  width: 90px;\n  height: 90px;\n  border-radius: 50%;\n  background: #e6f9f014;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbody.light_theme .agc_license_icon_inner {\n  background: #e6f9f0;\n\n}\n\n.agc_license_text h4 {\n  font-size: 40px;\n  font-weight: 600;\n  color: #eeeeee;\n  margin-bottom: 12px;\n}\n\nbody.light_theme .agc_license_text h4 {\n  color: #111;\n}\n\n.agc_license_text p {\n  color: #dadada;\n  font-size: 22px;\n  line-height: 1.6;\n  max-width: 100%;\n}\n\nbody.light_theme .agc_license_text p {\n  color: #353535;\n}\n\n.agc_about_license .agc_license_text {\n  color: #4B5563;\n  max-width: 650px;\n}\n\n.agc_btn_solid_gold_license {\n  background-color: #40434c1f;\n  color: #fff;\n  border: none;\n  border-radius: 3px;\n  padding: 10px;\n  transition: all 0.5s ease;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n}\n\nbody.light_theme .agc_btn_solid_gold_license {\n  background-color: #40434c;\n  color: #fff;\n}\n\n.agc_btn_solid_gold_license:hover {\n  box-shadow: 0px 5px 15px #b893526b;\n}\n\n/* COMPANY INFO SECTION */\n.agc_company_info_subtitle {\n  color: #D1AA67;\n  font-weight: 400;\n  position: relative;\n  letter-spacing: 0px;\n  text-transform: uppercase;\n  font-size: 30px;\n}\n\n.agc_company_info_subtitle::after {\n  content: '';\n  position: absolute;\n  bottom: -10px;\n  left: 0;\n  border-bottom: 2.5px solid #D1AA67;\n  width: 80px;\n}\n\n.agc_company_info_subtitle span {\n  color: #fff;\n}\n\nbody.light_theme .agc_company_info_subtitle span {\n  color: #0e0e0e;\n}\n\n.agc_company_info_card {\n  background: #22242C;\n  /* border: 1px solid #f2f2f217; */\n  position: relative;\n  border-radius: 0px;\n  padding: 32px 20px;\n  box-shadow: 0px 5px 25px rgba(0, 0, 0, 0.04);\n  min-height: 245px;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  clip-path: polygon(30px 0, 100% 0, 100% calc(100% - 30px), calc(100% - 30px) 100%, 0 100%, 0 30px);\n  -webkit-clip-path: polygon(30px 0, 100% 0, 100% calc(100% - 30px), calc(100% - 30px) 100%, 0 100%, 0 30px);\n}\n\n.about_icon_after {\n  position: absolute;\n  right: 40px;\n  max-width: 60px;\n  top: 40px;\n}\n\n.border_bottom_after {\n  position: absolute;\n  right: 1px;\n  bottom: 2px;\n}\n\nbody.light_theme .border_bottom_after {\n  opacity: 0.2;\n}\n\n.agc_company_info_section.information_section .row {\n  margin-top: 40px;\n}\n\nbody.light_theme .agc_company_info_card {\n  background: #e9e9e9;\n  border: 1px solid #f2f2f200;\n}\n\n.agc_company_info_header {\n  gap: 32px;\n  display: flex;\n  align-items: center;\n}\n\n.agc_company_info_icon {\n  width: 111px;\n  min-width: 111px;\n  height: 111px;\n  background: #22242C;\n  border: 3px solid #FFCC0030;\n  box-shadow: inset 0 0 22px rgb(0 0 0 / 45%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbody.light_theme .agc_company_info_icon {\n  background: #efefef;\n  box-shadow: inset 0 0 22px rgb(0 0 0 / 29%);\n}\n\n.agc_company_info_header h4 {\n  font-size: 20px;\n  position: relative;\n  font-weight: 500;\n  color: #D1AA67;\n  margin-bottom: 27px;\n}\n\n.agc_company_info_header h4::before {\n  content: '';\n  position: absolute;\n  bottom: -13px;\n  left: 0px;\n  width: 30px;\n  height: 3px;\n  background: #D1AA67;\n}\n\n.agc_company_info_header p {\n  font-size: 20px;\n  margin: 10px 0px 0px;\n}\n\n.agc_company_info_row {\n  display: flex;\n  justify-content: space-between;\n  padding: 16px 0;\n  border-bottom: 1px solid #f0f0f029;\n}\n\nbody.light_theme .agc_company_info_row {\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.agc_company_info_row:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.agc_company_info_label {\n  color: #9298a0;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.agc_company_info_value {\n  color: #f8f8f8;\n  font-size: 14px;\n  font-weight: 700;\n  text-align: right;\n  max-width: 65%;\n}\n\nbody.light_theme .agc_company_info_value {\n  color: #111;\n}\n\n/* GLOBAL PRESENCE SECTION */\n.agc_about_presence {\n  padding: 0 0 80px 0;\n  background: #fff;\n}\n\n.agc_office_card {\n  background: #fff;\n  border: 1px solid #eaeaea;\n  border-radius: 16px;\n  padding: 25px;\n  display: flex;\n  align-items: center;\n}\n\n.agc_office_icon {\n  width: 50px;\n  height: 50px;\n  background: #f8f9fa;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 20px;\n  flex-shrink: 0;\n}\n\n.agc_office_text h4 {\n  font-size: 1.1rem;\n}\n\n.agc_office_text p {\n  font-size: 0.9rem;\n}\n\n/* CTA SECTION */\n.agc_cta_banner {\n  position: relative;\n  background: linear-gradient(90deg, #b58d53 0%, #3a220b 100%);\n  border-radius: 20px;\n}\n\n.agc_cta_bg_shapes {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 20px;\n  overflow: hidden;\n  z-index: 1;\n}\n\n.agc_cta_bg_shapes::before,\n.agc_cta_bg_shapes::after {\n  content: \"\";\n  position: absolute;\n  border-radius: 50%;\n}\n\n.agc_cta_bg_shapes::before {\n  width: 390px;\n  height: 390px;\n  background: rgb(255 255 255 / 8%);\n  bottom: -150px;\n  left: -130px;\n}\n\n.agc_cta_bg_shapes::after {\n  width: 390px;\n  height: 390px;\n  background: rgb(255 255 255 / 6%);\n  top: -150px;\n  right: -50px;\n}\n\n.agc_cta_content {\n  position: relative;\n  z-index: 2;\n  max-width: 500px;\n}\n\n.agc_cta_content h2 {\n  font-size: 2.2rem;\n}\n\n.agc_cta_img_placeholder {\n  position: absolute;\n  right: 80px;\n  top: 39%;\n  transform: translateY(-50%);\n  z-index: 1;\n}\n\n.agc_about_cta h2 {\n  font-size: 42px;\n  color: #fff;\n}\n\n.agc_about_cta p {\n  font-size: 18px;\n}\n\n.agc_about_cta button.btn {\n  font-size: 14px;\n  padding: 13px 36px;\n}\n\n.agc_about_cta button.btn:focus {\n  background-color: #fff;\n  border: 1px solid #fff;\n  color: #000000;\n}\n\n.agc_cta_chest_img {\n  height: 380px !important;\n  object-fit: contain;\n}\n\n@media (max-width: 1440px) {\n\n  .agc_about_hero_content h1 {\n    font-size: 60px;\n  }\n\n  .agc_company_info_icon {\n    width: 80px;\n    min-width: 80px;\n    height: 80px;\n  }\n\n  .agc_company_info_header {\n    gap: 20px;\n  }\n\n  .agc_company_info_header p {\n    font-size: 18px;\n  }\n\n  .agc_about_hero_content button {\n    font-size: 18px;\n    padding: 18px 50px;\n  }\n\n  .agc_about_hero_content p {\n    font-size: 20px;\n  }\n\n  .agc_about_hero {\n    min-height: 800px;\n  }\n\n  .agc_about_title {\n    font-size: 48px;\n  }\n\n\n}\n\n\n\n@media (max-width: 1200px) {\n\n  .agc_about_hero_content h1 {\n    font-size: 48px;\n  }\n\n  .agc_company_info_header {\n    gap: 20px;\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .agc_company_info_header h4::before {\n    left: 0px;\n    margin: 0 auto;\n    right: 0px;\n  }\n\n  .agc_comp_icon_wrapper img {\n    max-width: 60px;\n    max-height: 60px;\n  }\n\n  .agc_about_hero_content button {\n    font-size: 18px;\n    padding: 18px 50px;\n  }\n\n  .agc_about_hero_content p {\n    font-size: 18px;\n  }\n\n  .agc_about_hero {\n    min-height: 600px;\n  }\n\n  .agc_about_title {\n    font-size: 36px;\n  }\n\n  .agc_about_marketplace_text {\n    font-size: 16px;\n  }\n\n  .agc_mission_card {\n    padding: 28px;\n  }\n\n  .agc_mission_content h3 {\n    font-size: 24px;\n  }\n\n  .agc_mission_content p {\n    font-size: 16px;\n  }\n\n  .agc_about_marketplace {\n    padding: 60px 0;\n  }\n\n  .agc_value_card {\n    padding: 26px;\n    width: calc(50.333% - 36px);\n  }\n\n  .agc_value_card h3 {\n    font-size: 26px;\n  }\n\n  .agc_value_card p {\n    font-size: 16px;\n  }\n\n  .agc_value_img {\n    max-height: 200px;\n  }\n\n  .agc_value_card_wide .agc_value_img_wrapper {\n    width: 170px;\n  }\n\n  .agc_about_text_muted {\n    font-size: 16px;\n  }\n\n  .agc_comp_card {\n    padding: 24px;\n  }\n\n  .agc_comp_card h4 {\n    font-size: 22px;\n  }\n\n  .agc_comp_card p {\n    font-size: 16px;\n  }\n\n  .agc_comp_icon_wrapper {\n    width: 100px;\n    height: 100px;\n  }\n\n  .agc_about_comparison {\n    padding: 59px 0;\n    min-height: 500px;\n  }\n\n  .agc_oversight_card {\n    flex-direction: column;\n    gap: 24px;\n  }\n\n  .agc_about_team {\n    padding: 50px 0 40px 0;\n  }\n\n  .agc_license_text h4 {\n    font-size: 26px;\n  }\n\n  .agc_license_text p {\n    font-size: 16px;\n  }\n\n  .agc_about_license .agc_license_text {\n    max-width: 70%;\n  }\n\n  .agc_license_icon_outer {\n    width: 90px;\n    height: 90px;\n  }\n\n  .agc_license_icon_inner {\n    width: 70px;\n    height: 70px;\n  }\n\n  .agc_about_cta h2 {\n    font-size: 32px;\n  }\n\n\n  .agc_cta_chest_img {\n    height: 320px !important;\n  }\n\n  .agc_cta_img_placeholder {\n    right: 20px;\n  }\n\n\n}\n\n/* Responsive adjustments */\n@media (max-width: 991px) {\n\n  .agc_comp_col_right {\n    width: 100%;\n  }\n\n  .agc_company_info_card {\n    margin-bottom: 24px;\n  }\n\n  .agc_company_info_section.information_section {\n    padding: 70px 0px 10px;\n  }\n\n  .agc_about_hero {\n    min-height: 450px;\n  }\n\n\n  .agc_about_hero_content h1 {\n    font-size: 2.8rem;\n  }\n\n  .agc_comparison_layout {\n    flex-direction: column;\n  }\n\n  .agc_value_card {\n    width: calc(50% - 20px);\n  }\n\n  .agc_cta_banner {\n    flex-direction: column;\n    text-align: center;\n    padding: 40px !important;\n  }\n\n  .agc_cta_content {\n    margin-bottom: 30px;\n  }\n\n  .agc_cta_img_placeholder {\n    position: relative;\n    right: 0;\n    bottom: 0;\n    top: 0px;\n    transform: translateY(0%);\n  }\n\n  .agc_cta_chest_img {\n    height: 180px !important;\n  }\n}\n\n@media (max-width:991px) {\n\n\n  .agc_about_hero_content h1 {\n    font-size: 2.2rem;\n  }\n\n  .agc_about_hero_content button {\n    font-size: 16px;\n    padding: 14px 50px;\n  }\n\n  .agc_about_marketplace {\n    padding: 40px 0;\n  }\n\n  .agc_about_values {\n    padding: 40px 0;\n  }\n\n  .agc_comp_col_left {\n    margin-top: 0px;\n  }\n\n  .agc_about_oversight {\n    padding: 40px 0 0 0;\n  }\n\n  .agc_about_title {\n    font-size: 30px;\n  }\n\n  .agc_about_hero_content button {\n    margin: 0px;\n  }\n\n  .agc_btn_black {\n    margin-left: 0;\n    margin-top: 0;\n  }\n\n  .agc_scan_download_wrapper {\n    margin-top: 0px;\n  }\n\n  .agc_value_card {\n    width: 100%;\n  }\n\n  .agc_oversight_card.flex-row {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n\n  .agc_oversight_img {\n    margin-right: 0;\n    margin-bottom: 20px;\n  }\n\n  .agc_oversight_info.ms-4 {\n    margin-left: 0 !important;\n  }\n\n  .agc_license_card {\n    text-align: center;\n  }\n\n  .agc_license_left {\n    gap: 20px;\n  }\n\n  .agc_license_text h4 {\n    font-size: 24px;\n  }\n\n  .agc_license_text p {\n    font-size: 15px;\n  }\n\n  .agc_btn_solid_gold_license {\n    padding: 8px;\n    font-size: 14px;\n  }\n\n  .agc_license_card {\n    padding: 24px 30px;\n  }\n\n  .agc_btn_solid_gold {\n    margin-top: 20px !important;\n  }\n\n  .agc_license_icon_inner {\n    width: 50px;\n    height: 50px;\n    padding: 10px;\n  }\n\n  .agc_license_icon_outer {\n    width: 60px;\n    height: 60px;\n  }\n\n  .agc_cta_chest_img {\n    height: 260px !important;\n  }\n\n\n  .agc_license_icon_outer {\n    margin-right: 0;\n    margin-bottom: 15px;\n  }\n\n  .agc_license_right {\n    margin-top: 20px;\n  }\n\n  .agc_about_license .agc_license_text {\n    max-width: 100%;\n    text-align: left;\n  }\n\n}\n\n\n\n\n/* --- Profile Modal Styles --- */\n.agc_profile_modal_overlay {\n  position: fixed;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  background: rgb(44 44 44 / 20%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 999999999;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5%);\n  padding: 20px;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition:\n    opacity 0.35s ease,\n    visibility 0.35s ease,\n    backdrop-filter 0.35s ease;\n}\n\nbody.light_theme .agc_profile_modal_overlay {\n  background: rgb(255 255 255 / 20%);\n}\n\n.agc_profile_modal_overlay.is-open {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n}\n\n.agc_profile_modal_content {\n  background: rgb(4 4 4 / 50%);\n  border-radius: 16px;\n  width: 100%;\n  max-width: 1000px;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5%);\n  max-height: 60vh;\n  overflow: hidden;\n  position: relative;\n  padding: 32px;\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.28);\n  display: flex;\n  flex-direction: column;\n  opacity: 0;\n  transform: translateY(28px) scale(0.94);\n  transition:\n    opacity 0.38s cubic-bezier(0.16, 1, 0.3, 1),\n    transform 0.38s cubic-bezier(0.16, 1, 0.3, 1);\n  will-change: transform, opacity;\n}\n\nbody.light_theme .agc_profile_modal_content {\n  background: rgb(255 255 255 / 20%);\n}\n\n.agc_profile_modal_overlay.is-open .agc_profile_modal_content {\n  opacity: 1;\n  transform: translateY(0) scale(1);\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n  .agc_profile_modal_overlay,\n  .agc_profile_modal_content {\n    transition: none;\n  }\n\n  .agc_profile_modal_content {\n    transform: none;\n  }\n}\n\n.agc_profile_modal_body {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n@media (min-width: 768px) {\n  .agc_profile_modal_body {\n    flex-direction: row;\n    gap: 40px;\n    align-items: stretch;\n  }\n}\n\n.agc_profile_modal_close {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  background: none;\n  border: none;\n  padding: 0px;\n  color: #e9e9e9;\n  font-size: 32px;\n  cursor: pointer;\n  line-height: 1;\n  transition: color 0.3s;\n}\n\nbody.light_theme .agc_profile_modal_close {\n  color: #111;\n}\n\n.agc_profile_modal_close:hover {\n  color: #D1AA67;\n}\n\n.agc_profile_modal_img_wrapper {\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 260px;\n  aspect-ratio: 3 / 4;\n  border-radius: 12px;\n  overflow: hidden;\n  margin: 0 auto 30px auto;\n  align-self: flex-start;\n  background: #f4f5f6;\n}\n\n.agc_license_right {\n  max-width: 150px;\n}\n\n@media (min-width: 768px) {\n\n  .agc_profile_modal_img_wrapper {\n    width: 260px;\n    margin-bottom: 0;\n  }\n}\n\n.agc_profile_modal_img {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n  object-position: center top;\n  border-radius: 12px;\n}\n\n.agc_profile_modal_info {\n  flex: 1;\n  overflow-y: auto;\n  padding-right: 15px;\n}\n\n.agc_profile_modal_info::-webkit-scrollbar {\n  width: 6px;\n}\n\n.agc_profile_modal_info::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.agc_profile_modal_info::-webkit-scrollbar-thumb {\n  background: #D1AA67;\n  border-radius: 4px;\n}\n\n.agc_profile_modal_info h3 {\n  font-size: 22px;\n  margin-bottom: 10px;\n  color: #ebebeb;\n  font-weight: 600;\n}\n\nbody.light_theme .agc_profile_modal_info h3 {\n  color: #111;\n}\n\n.agc_profile_modal_info .agc_role {\n  display: block;\n  color: #D1AA67;\n  font-size: 16px;\n  margin-bottom: 20px;\n  font-weight: 600;\n}\n\n.agc_profile_modal_info p {\n  color: #afafaf;\n  line-height: 1.7;\n  font-size: 15px;\n  margin: 0;\n  white-space: pre-wrap;\n}\n\nbody.light_theme .agc_profile_modal_info p {\n  color: #444;\n}\n\n.agc_profile_desc_clamp {\n  display: -webkit-box;\n  -webkit-line-clamp: 8;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.agc_profile_desc_clamp_15 {\n  display: -webkit-box;\n  -webkit-line-clamp: 9;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.agc_profile_desc_clamp_4 {\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.agc_profile_modal_img_wrapper_small {\n  max-width: 100px !important;\n  width: 100px !important;\n}\n\n\n/* fix kero - Dark theme support for About pages */\nhtml[data-theme=\"dark\"] .agc_about_page_wrapper,\nbody:not(.light_theme) .agc_about_page_wrapper {\n  background-color: #181a20;\n  color: #ffffff;\n}\n\nhtml[data-theme=\"dark\"] .agc_about_page_wrapper h1,\nhtml[data-theme=\"dark\"] .agc_about_page_wrapper h2,\nhtml[data-theme=\"dark\"] .agc_about_page_wrapper h3,\nhtml[data-theme=\"dark\"] .agc_about_page_wrapper h5,\nbody:not(.light_theme) .agc_about_page_wrapper h1,\nbody:not(.light_theme) .agc_about_page_wrapper h2,\nbody:not(.light_theme) .agc_about_page_wrapper h3,\nbody:not(.light_theme) .agc_about_page_wrapper h5 {\n  color: #ffffff;\n}\n\nhtml[data-theme=\"dark\"] .agc_about_text_muted,\nbody:not(.light_theme) .agc_about_text_muted {\n  color: #a0a0a0;\n}\n\nhtml[data-theme=\"dark\"] .agc_scan_popup,\nbody:not(.light_theme) .agc_scan_popup {\n  background: #1a222d;\n}\n\nhtml[data-theme=\"dark\"] .agc_scan_popup::before,\nbody:not(.light_theme) .agc_scan_popup::before {\n  border-top-color: #1a222d;\n}\n\nhtml[data-theme=\"dark\"] .agc_comp_card,\nhtml[data-theme=\"dark\"] .agc_value_card,\nhtml[data-theme=\"dark\"] .agc_company_profile_card,\nhtml[data-theme=\"dark\"] .agc_exec_card,\nhtml[data-theme=\"dark\"] .agc_team_member_card,\nhtml[data-theme=\"dark\"] .agc_oversight_card,\nhtml[data-theme=\"dark\"] .agc_license_card,\nbody:not(.light_theme) .agc_comp_card,\nbody:not(.light_theme) .agc_value_card,\nbody:not(.light_theme) .agc_company_profile_card,\nbody:not(.light_theme) .agc_exec_card,\nbody:not(.light_theme) .agc_team_member_card,\nbody:not(.light_theme) .agc_oversight_card,\nbody:not(.light_theme) .agc_license_card {\n  background: #181a20;\n  color: #ffffff;\n  border: 1px solid #eaeaea17;\n}\n\nhtml[data-theme=\"dark\"] .agc_comp_card h3,\nhtml[data-theme=\"dark\"] .agc_value_card h3,\nhtml[data-theme=\"dark\"] .agc_company_profile_card h2,\nhtml[data-theme=\"dark\"] .agc_exec_card h3,\nhtml[data-theme=\"dark\"] .agc_team_member_card h3,\nhtml[data-theme=\"dark\"] .agc_oversight_card h3,\nhtml[data-theme=\"dark\"] .agc_license_card h3,\nbody:not(.light_theme) .agc_comp_card h3,\nbody:not(.light_theme) .agc_value_card h3,\nbody:not(.light_theme) .agc_company_profile_card h2,\nbody:not(.light_theme) .agc_exec_card h3,\nbody:not(.light_theme) .agc_team_member_card h3,\nbody:not(.light_theme) .agc_oversight_card h3,\nbody:not(.light_theme) .agc_license_card h3 {\n  color: #ffffff;\n}\n\nhtml[data-theme=\"dark\"] .agc_btn_black,\nbody:not(.light_theme) .agc_btn_black {\n  background: #ffffff;\n  color: #111;\n}\n\nhtml[data-theme=\"dark\"] .agc_btn_black:hover,\nbody:not(.light_theme) .agc_btn_black:hover {\n  background: #e0e0e0;\n}\n\nhtml[data-theme=\"dark\"] .agc_role,\nbody:not(.light_theme) .agc_role {\n  color: #a0aab5;\n}\n\n/* License Certificate Modal Styling */\n.agc_about_license .agc_modal_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.75);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 99999999;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: opacity 0.3s ease, visibility 0.3s ease;\n}\n\nbody.light_theme .agc_about_license .agc_modal_overlay {\n  background-color: rgb(255 255 255 / 50%);\n}\n\n.agc_about_license .agc_modal_overlay.active {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n}\n\n.agc_about_license .agc_modal_container {\n  background: #1a1c2204;\n  border-radius: 0px;\n  width: 90%;\n  max-width: 810px;\n  height: auto;\n  aspect-ratio: 1.214 / 1;\n  max-height: 95vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 25px 50px -12px rgba(209, 170, 103, 0.5);\n  overflow: hidden;\n  position: relative;\n  transform: translate3d(0, 20px, 0) scale(0.95);\n  -webkit-transform: translate3d(0, 20px, 0) scale(0.95);\n  transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1), -webkit-transform 0.35s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.agc_about_license .agc_modal_overlay.active .agc_modal_container {\n  transform: translate3d(0, 0, 0) scale(1);\n  -webkit-transform: translate3d(0, 0, 0) scale(1);\n}\n\nbody.light_theme .agc_about_license .agc_modal_container {\n  background: #ffffff;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);\n}\n\n.agc_modal_close_btn.absolute_close {\n  position: absolute;\n  top: 12px;\n  right: 30px;\n  z-index: 10;\n  background-color: transparent;\n  color: #121212;\n  /* width: 30px; */\n  padding: 0px;\n  /* height: 30px; */\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: none;\n}\n\n.agc_modal_close_btn.absolute_close:hover {\n  /* background-color: rgba(209, 170, 103, 0.9); */\n  color: #000000;\n}\n\n.agc_modal_body.full_body {\n  padding: 0;\n  background-color: #111216;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  border-radius: 20px;\n  overflow: hidden;\n  /* Clip border-radius properly on iOS Safari */\n  transform: translate3d(0, 0, 0);\n  -webkit-transform: translate3d(0, 0, 0);\n}\n\nbody.light_theme .agc_modal_body.full_body {\n  background-color: #f7f9fb;\n}\n\n.agc_modal_body.full_body .agc_pdf_iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n  border-radius: 0px;\n  background-color: #ffffff;\n  box-shadow: none;\n}\n\n\n\n/* Mobile Responsiveness */\n@media (max-width: 768px) {\n  .agc_about_license .agc_modal_container {\n    width: 95%;\n    height: auto;\n    aspect-ratio: 1.414 / 1;\n    max-height: 90vh;\n    border-radius: 0px;\n  }\n\n  .agc_modal_body.full_body {\n    padding: 0;\n    border-radius: 0px;\n  }\n\n  .agc_modal_body.full_body .agc_pdf_iframe {\n    border-radius: 0px;\n  }\n}\n\n\n@media (max-width:767px) {\n\n  .agc_about_hero_btns {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .agc_about_hero {\n    min-height: 100%;\n    padding: 42px 0px 35px;\n  }\n\n  .agc_values_grid {\n    gap: 24px;\n  }\n\n  .agc_about_page_wrapper--team {\n    padding-top: 24px;\n  }\n\n  .agc_about_license .agc_modal_container {\n    aspect-ratio: 1.0 / 1 !important;\n    max-height: 100vh;\n  }\n\n  .agc_company_info_section.information_section {\n    padding: 40px 0px 0px;\n  }\n\n  .agc_company_info_subtitle {\n    font-size: 22px;\n  }\n\n  .agc_company_info_value {\n    font-size: 12px;\n  }\n\n  .agc_company_info_icon {\n    width: 64px;\n    height: 64px;\n    min-width: 64px;\n  }\n\n  .agc_company_info_icon img {\n    width: 30px;\n  }\n\n  .agc_company_info_header p {\n    font-size: 15px;\n  }\n\n  .agc_company_info_header h4 {\n    font-size: 17px;\n  }\n\n  .agc_company_info_row {\n    padding: 10px 0;\n\n  }\n\n  .agc_company_info_label {\n    font-size: 12px;\n  }\n\n  .agc_btn_solid_gold {\n    padding: 10px 28px;\n    font-size: 12px;\n  }\n\n  .agc_team_name_role h4 {\n    font-size: 18px;\n  }\n\n  .agc_team_name_role span {\n    font-size: 14px;\n  }\n\n  .agc_comp_col_left {\n    gap: 24px;\n  }\n\n  h2.agc_about_title.mb-5 {\n    margin-bottom: 22px !important;\n  }\n\n  .agc_comp_card h4 {\n    margin: 14px 0 10px 0;\n    font-size: 18px;\n  }\n\n  .agc_comp_icon_wrapper img {\n    max-width: 40px;\n    max-height: 40px;\n  }\n\n  .agc_about_hero_content h1 {\n    margin-bottom: 15px;\n  }\n\n  .agc_mission_card {\n    padding: 24px;\n  }\n\n  .agc_mission_content h3 {\n    font-size: 20px;\n  }\n\n  .agc_value_card.agc_value_card_center {\n    flex-direction: column-reverse;\n  }\n\n  .agc_about_hero_content button {\n    margin: 0px;\n    width: 280px;\n  }\n\n  .agc_about_hero_content p {\n    font-size: 16px;\n    margin-bottom: 20px;\n  }\n\n  .agc_profile_modal_img_wrapper {\n    max-width: 150px;\n  }\n\n  .agc_about_marketplace {\n    padding: 30px 0 0px;\n  }\n\n  .agc_about_title {\n    font-size: 24px;\n  }\n\n  .agc_about_subtitle {\n    font-size: 16px;\n  }\n\n  .agc_about_marketplace_text {\n    font-size: 15px;\n    padding-top: 0px;\n  }\n\n  .agc_mission_icon_box {\n    width: 60px;\n    height: 60px;\n    margin-right: 16px;\n  }\n\n  .agc_mission_content p {\n    font-size: 15px;\n    margin-top: 5px;\n  }\n\n  .agc_coin_ticker_wrapper {\n    padding: 20px 0px;\n  }\n\n  .agc_about_marketplace .mb-5 {\n    margin-bottom: 2rem !important;\n  }\n\n  .agc_about_hero_content button {\n    font-size: 14px;\n    padding: 12px 50px;\n  }\n\n  .agc_scan_text {\n    font-size: 14px;\n  }\n\n  .agc_scan_download_wrapper {\n    margin-top: 0px;\n  }\n\n  section.agc_about_cta.mb-5.pb-5 {\n    padding-bottom: 0px !important;\n  }\n\n  .agc_license_icon_outer {\n    width: 50px;\n    height: 50px;\n    min-width: 50px;\n  }\n\n  .agc_about_values {\n    padding: 20px 0 10px;\n  }\n\n  .agc_about_page_wrapper--team .agc_about_exec_directors {\n    padding-top: 20px;\n    padding-bottom: 0px !important;\n  }\n\n  .agc_profile_modal_overlay {\n    align-items: end;\n    padding: 0px;\n  }\n\n  .text-center.mb-5 {\n    margin-bottom: 15px !important;\n  }\n\n  .agc_value_card h3 {\n    font-size: 18px;\n  }\n\n  .agc_value_card.agc_value_card_wide {\n    flex-direction: column-reverse;\n  }\n\n  .agc_about_comparison {\n    padding: 30px 0;\n    min-height: 100%;\n  }\n\n  .agc_comparison_layout {\n    gap: 30px;\n  }\n\n  .agc_section_header_line {\n    font-size: 16px;\n  }\n\n  .agc_oversight_card {\n    padding: 24px;\n  }\n\n  .agc_oversight_info h3 {\n    font-size: 20px;\n  }\n\n  .agc_oversight_img_wrapper_large {\n    width: 100%;\n    margin-right: 0px;\n  }\n\n  .agc_oversight_card.agc_large_card {\n    padding: 24px;\n  }\n\n  .agc_oversight_card.agc_large_card h3 {\n    font-size: 20px;\n  }\n\n  .agc_oversight_card.agc_large_card span.agc_role {\n    font-size: 14px;\n  }\n\n  .agc_oversight_card.agc_large_card .agc_oversight_info p {\n    font-size: 14px;\n  }\n\n  .agc_oversight_info p,\n  .agc_team_info p {\n    text-align: justify;\n    text-justify: inter-word;\n    -webkit-hyphens: auto;\n    font-size: 14px;\n    -moz-hyphens: auto;\n    -ms-hyphens: auto;\n    hyphens: auto;\n    word-break: break-word;\n  }\n\n  .agc_oversight_info .agc_role {\n    font-size: 14px;\n  }\n\n  .agc_about_team {\n    padding: 20px 0 20px 0;\n  }\n\n  .agc_about_license {\n    padding: 30px 0 30px 0;\n  }\n\n  .agc_license_card {\n    flex-direction: column;\n  }\n\n  .agc_license_text h4 {\n    font-size: 20px;\n  }\n\n  .agc_license_text p {\n    font-size: 14px;\n  }\n\n  .agc_btn_solid_gold_license {\n    font-size: 13px;\n  }\n\n  .agc_license_card {\n    padding: 20px;\n  }\n\n  .agc_company_info_card {\n    padding: 24px;\n    min-height: 230px;\n  }\n\n  .agc_about_cta h2 {\n    font-size: 24px;\n  }\n\n  .agc_about_cta p {\n    font-size: 15px;\n  }\n\n  .agc_cta_content {\n    padding-left: 0px !important;\n  }\n\n  .agc_about_cta button.btn {\n    font-size: 14px;\n    padding: 12px 21px;\n  }\n\n  .agc_comp_col_right {\n    gap: 30px;\n  }\n\n  .agc_value_card.agc_value_card_center h3 {\n    order: 3;\n  }\n\n  .agc_value_card.agc_value_card_center .agc_value_img {\n    order: 3;\n  }\n\n  .agc_value_card.agc_value_card_center p {\n    order: 1;\n  }\n\n  .agc_cta_banner {\n    padding: 19px !important;\n  }\n\n  .agc_team_card {\n    min-height: 100%;\n  }\n\n\n  .agc_btn_link_gold {\n    margin-top: 24px !important;\n  }\n\n  .agc_oversight_img_wrapper {\n    width: 100%;\n    margin-right: 0px;\n  }\n\n  .col-lg-5.mb-5 {\n    margin-bottom: 15px !important;\n  }\n\n  .agc_about_hero_content button img {\n    width: 20px;\n  }\n\n  .agc_profile_modal_content {\n    padding: 20px;\n    border-radius: 18px 18px 0px 0px;\n    max-height: 92vh;\n    min-height: 75vh;\n  }\n\n  .agc_profile_modal_info h3 {\n    font-size: 18px;\n  }\n\n  .agc_profile_modal_info .agc_role {\n    font-size: 14px;\n    margin-bottom: 12px;\n  }\n\n  .agc_profile_modal_info {\n    padding-right: 0px;\n  }\n\n  .agc_profile_modal_info p {\n    font-size: 14px;\n  }\n\n  .agc_cta_content {\n    margin-bottom: 0px;\n  }\n\n  .agc_about_text_muted {\n    font-size: 15px;\n  }\n\n  .agc_comp_card p {\n    font-size: 15px;\n  }\n\n  .agc_comp_icon_wrapper {\n    width: 70px;\n    height: 70px;\n    border-radius: 18px;\n  }\n\n  .agc_value_card p {\n    font-size: 14px;\n  }\n\n  .agc_value_img {\n    max-height: 150px;\n    margin-top: 0px !important;\n  }\n\n  .agc_value_card_wide .agc_value_img_wrapper {\n    width: 150px;\n  }\n\n  .agc_about_hero_content h1 {\n    font-size: 26px;\n  }\n\n  .agc_about_license .agc_modal_container {\n    width: 100%;\n  }\n\n}\n\n@media screen and (max-width:667px) {\n\n  .agc_about_title {\n    font-size: 18px;\n    margin-bottom: 12px !important;\n  }\n\n  .agc_about_hero_content button {\n    font-size: 12px;\n    padding: 10px 50px;\n  }\n\n  .agc_mission_content p {\n    font-size: 14px;\n  }\n\n  .agc_mission_content h3 {\n    font-size: 18px;\n  }\n\n}\n\n\n@media screen and (max-width:480px) {\n\n  .agc_about_hero_content h1 {\n    font-size: 24px;\n  }\n\n  .agc_about_hero_content p {\n    font-size: 15px;\n  }\n\n  .agc_about_cta p {\n    font-size: 14px;\n  }\n\n  .agc_company_info_value {\n    font-size: 12px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
